/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';
import authHeader from './auth-header';
import http from './http-common';
import { API_URLU } from '../config/constant';
const getUserById = (id) => {
  return axios.get(API_URLU + 'user/' + id, { headers: authHeader() });
};

const getDaySales = (branch_code, collection_date, cmp_id) => {
  return axios.get(API_URLU + 'day_sales/' + branch_code + '/' + collection_date + '/' + cmp_id, { headers: authHeader() });
};

const getUserSales = (createdBy, status) => {
  return axios.get(API_URLU + 'sales/' + createdBy + '/' + status, { headers: authHeader() });
};

const getAllSales = (status) => {
  return axios.get(API_URLU + 'sales/' + status, { headers: authHeader() });
};

const getPendingSales = (cmp_id, usr_id) => {
  return axios.get(API_URLU + 'pending_sales/' + cmp_id + '/' + usr_id, { headers: authHeader() });
};

const getApprovedSales = (cmp_id) => {
  return axios.get(API_URLU + 'approved-sales/' + cmp_id, { headers: authHeader() });
};

const getUserShops = (id) => {
  return axios.get(API_URLU + 'user_shops/' + id, { headers: authHeader() });
};

const getAllShops = (id) => {
  return axios.get(API_URLU + 'all_shops/' + id, { headers: authHeader() });
};

const getUsers = () => {
  return axios.get(API_URLU + 'user', { headers: authHeader() });
};

const postUser = (data) => {
  return axios.post(API_URLU + 'user', data, { headers: authHeader() });
};

const getCompById = (id) => {
  return axios.get(API_URLU + 'company/' + id, { headers: authHeader() });
};

const getCompanies = () => {
  return axios.get(API_URLU + 'company', { headers: authHeader() });
};

const postComp = (data) => {
  return axios.post(API_URLU + 'company', data, { headers: authHeader() });
};

const getSystemById = (id) => {
  return axios.get(API_URLU + 'system' + id, { headers: authHeader() });
};

const getMaxDate = (cmpid, branch_code) => {
  return axios.get(API_URLU + 'max-date/' + cmpid + '/' + branch_code, { headers: authHeader() });
};

const getSaleStatus = (cmpid, branch_code) => {
  return axios.get(API_URLU + 'sale-status/' + cmpid + '/' + branch_code, { headers: authHeader() });
};

const getPastDays = (status) => {
  return axios.get(API_URLU + 'open-days/' + status, { headers: authHeader() });
};

const getDaysStatus = () => {
  return axios.get(API_URLU + 'check-days', { headers: authHeader() });
};

const getSystems = () => {
  return axios.get(API_URLU + 'system', { headers: authHeader() });
};

const postSystem = (data) => {
  return axios.post(API_URLU + 'system', data, { headers: authHeader() });
};

const postUserComp = (data) => {
  return axios.post(API_URLU + 'ucompany', data, { headers: authHeader() });
};

const tenantPost = (data) => {
  return axios.post(API_URLU + "create?tenantId=" + data.cmpId + '&userId=' + data.usrId + '&username=' + data.username + '&sstId=' + data.sstId, {
    headers: authHeader(),
  });
};

const setTenants = (id) => {
  return axios.get(API_URLU + "set-tenants?tenantId=" + id, {
    headers: authHeader(),
  });
};

const getTenants = (id) => {
  return axios.get(API_URLU + "get-tenant?tenantId=" + id, {
    headers: authHeader(),
  });
};

const getUserComp = (id) => {
  return axios.get(API_URLU + 'user-companies?userId=' + id, { headers: authHeader() });
};

const getSavingsUserComp = (id) => {
  return axios.get(API_URLU + 'savings-user-companies?userId=' + id, { headers: authHeader() });
};

const postUserSystems = (data) => {
  return axios.post(API_URLU + 'user-systems', data, { headers: authHeader() });
};

const getCompSystems = () => {
  return axios.get(API_URLU + 'company-systems', { headers: authHeader() });
};

const getUserCompSystems = () => {
  return axios.get(API_URLU + 'user-company-systems', { headers: authHeader() });
};

const getUserCompUSystems = () => {
  return axios.get(API_URLU + 'user-company-usystems', { headers: authHeader() });
};

// const getCustomerById = (id) => {
//   return axios.get(API_URLU + 'customer/' + id, { headers: authHeader() });
// };

const getCustomerByCmpId = (data) => {
  return axios.get(API_URLU + 'cmp_customer/' + data.id + '/' + data.offset + '/' + data.pageSize, { headers: authHeader() });
};

const getCustomerByCmpIdAndId = (data) => {
  return axios.get(API_URLU + 'cmp_customer-id/' + data.id + '/' + data.nationalId + '/' + data.offset + '/' + data.pageSize, {
    headers: authHeader()
  });
};

const getCustomers = () => {
  return axios.get(API_URLU + 'customer', { headers: authHeader() });
};

const postCustomer = (data) => {
  return axios.post(API_URLU + 'customer', data, { headers: authHeader() });
};

const postSale = (data) => {
  return axios.post(API_URLU + 'icr_sales', data, { headers: authHeader() });
};

const postDay = (data) => {
  return axios.post(API_URLU + 'open-days', data, { headers: authHeader() });
};

const putSale = (id, data) => {
  return axios.put(API_URLU + 'icr_sales/' + id, data, { headers: authHeader() });
};

const putVatRate = (id, data) => {
  return axios.put(API_URLU + 'vat-rates/' + id, data, { headers: authHeader() });
};

const putStdRate = (id, data) => {
  return axios.put(API_URLU + 'standard-rates/' + id, data, { headers: authHeader() });
};

const putGenRate = (id, data) => {
  return axios.put(API_URLU + 'general-rates/' + id, data, { headers: authHeader() });
};

const putIstPeriod = (id, data) => {
  return axios.put(API_URLU + 'ist-periods/' + id, data, { headers: authHeader() });
};

const putIstSuppliers = (id, data) => {
  return axios.put(API_URLU + 'ist-suppliers/' + id, data, { headers: authHeader() });
};

const putDay = (id, data) => {
  return axios.put(API_URLU + 'open-days/' + id, data, { headers: authHeader() });
};

const getSalesByDate = (cmp_id, usr_id, sdate, edate) => {
  return axios.get(API_URLU + 'sales_date/' + cmp_id + '/' + usr_id + '/' + sdate + '/' + edate, { headers: authHeader() });
};

const getAdminSalesByDate = (cmp_id, sdate, edate) => {
  return axios.get(API_URLU + 'admin-datesales/' + cmp_id + '/' + sdate + '/' + edate, { headers: authHeader() });
};

const getSalesByShop = (cmp_id, branch_code, usr_id, first_date, last_date) => {
  return axios.get(API_URLU + 'sales_shop/' + cmp_id + '/' + branch_code + '/' + usr_id + '/' + first_date + '/' + last_date, {
    headers: authHeader()
  });
};

const getAdminSalesByShop = (cmp_id, branch_code, first_date, last_date) => {
  return axios.get(API_URLU + 'admin-shopsales/' + cmp_id + '/' + branch_code + '/' + first_date + '/' + last_date, {
    headers: authHeader()
  });
};

const delSale = (id) => {
  return axios.delete(API_URLU + 'icr_sales/' + id, { headers: authHeader() });
};

const delVatRate = (id) => {
  return axios.delete(API_URLU + 'vat-rates/' + id, { headers: authHeader() });
};

const delStdRate = (id) => {
  return axios.delete(API_URLU + 'standard-rates/' + id, { headers: authHeader() });
};

const delGenRate = (id) => {
  return axios.delete(API_URLU + 'general-rates/' + id, { headers: authHeader() });
};

const delIstProduct = (id) => {
  return axios.delete(API_URLU + 'ist-products/' + id, { headers: authHeader() });
};

const delCashRate = (id) => {
  return axios.delete(API_URLU + 'ist-cashRates/' + id, { headers: authHeader() });
};

const delMarkup = (id) => {
  return axios.delete(API_URLU + 'ist-checkOffMarkup/' + id, { headers: authHeader() });
};

// const putCustomer = (id, data) => {
//   return axios.put(API_URLU + 'customer/' + id, data, { headers: authHeader() });
// };

const putCustomer = (data) => {
  return axios.put(API_URLU + "customer/" + data.custId, data, {
    headers: authHeader(),
  });
};

const getEmployeeById = (id) => {
  return axios.get(API_URLU + 'chr_employee/' + id, { headers: authHeader() });
};

const getEmployeeByUsername = (name) => {
  return axios.get(API_URLU + 'chr_by_username/' + name, { headers: authHeader() });
};

const getEmployees = () => {
  return axios.get(API_URLU + 'chr_employee', { headers: authHeader() });
};

const getPagedEmployees = (offset, pageSize) => {
  return axios.get(API_URLU + 'employee/' + offset + '/' + pageSize, { headers: authHeader() });
};

// const postEmployee = (data) => {
//   return axios.post(API_URLU + 'employee', data, { headers: authHeader() });
// };

// const putEmployee = (id, data) => {
//   return axios.put(API_URLU + 'employee/' + id, data, { headers: authHeader() });
// };

const getClassification = () => {
  return axios.get(API_URLU + 'classification', { headers: authHeader() });
};

const getGeneral = () => {
  return axios.get(API_URLU + 'general', { headers: authHeader() });
};

const postTempBranch = (data) => {
  return axios.post(API_URLU + 'tbranch', data, { headers: authHeader() });
};

const getTempBranch = () => {
  return axios.get(API_URLU + 'tbranch', { headers: authHeader() });
};

const saveInvoice = (invoice) => {
  return axios.post(API_URLU + 'SaveInvoice', invoice, { headers: authHeader() });
};

const getInvoiceInfo = () => {
  return axios.get(API_URLU + 'getInfo', { headers: authHeader() });
};

const getScheduledLeaves = () => {
  return axios.get(API_URLU + 'scheduled_leaves', { headers: authHeader() });
};

const postLeaveSchedule = (data) => {
  return axios.post(API_URLU + 'scheduled_leaves', data, { headers: authHeader() });
};

const getLeaveAccruals = () => {
  return axios.get(API_URLU + 'leave_accruals', { headers: authHeader() });
};

const getLeaveApplications = () => {
  return axios.get(API_URLU + 'leave_applications', { headers: authHeader() });
};

const postLeaveApplication = (data) => {
  return axios.post(API_URLU + 'leave_applications', data, { headers: authHeader() });
};

const getLeaveTransactions = () => {
  return axios.get(API_URLU + 'leave_transactions', { headers: authHeader() });
};

const getLeaveRejections = () => {
  return axios.get(API_URLU + 'leave_rejections', { headers: authHeader() });
};

const getLeaveTypes = () => {
  return axios.get(API_URLU + 'leave_types', { headers: authHeader() });
};

const getReturnDate = (data) => {
  return axios.get(
    API_URLU +
    'return_date?startDate=' +
    data.startDate +
    '&appliedDays=' +
    data.appliedDays +
    '&leaveCode=' +
    data.leaveCode +
    '&cmpId=' +
    data.cmpId,
    { headers: authHeader() }
  );
};

// const uploadFile = (file, onUploadProgress) => {
//   let formData = new FormData();

//   formData.append("file", file);
//   return axios.post(API_URLU + "singleUpload/", formData, { headers: authHeader(), onUploadProgress })}

// const getFiles = () => {
//   return axios.get(API_URLU + "files/", { headers: authHeader() })}

const uploadFile = (file) => {
  let formData = new FormData();

  formData.append('file', file);

  return http.post('/singleUpload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const uploadExcel = (file) => {
  let formData = new FormData();

  formData.append('file', file);

  return http.post('/upload_chr_employees', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const getFiles = () => {
  return http.get('/files');
};

const updatePass = (data) => {
  return axios.patch(API_URLU + 'changepwd', data, { headers: authHeader() });
};

const updateUser = (data) => {
  return axios.get(
    API_URLU + 'update-user-profile?id=' + data.id + '&longName=' + data.longName + '&email=' + data.email + '&phone=' + data.phone,
    { headers: authHeader() }
  );
};

const updateUserImg = (data) => {
  return axios.get(API_URLU + 'update-user-image?id=' + data.id + '&photoUrl=' + data.photoUrl, { headers: authHeader() });
};

const getStockCodes = (cmp_id) => {
  return axios.get(API_URLU + 'supplier-products/' + cmp_id, { headers: authHeader() });
};

const getCompanyProducts = (cmp_id) => {
  return axios.get(API_URLU + 'company-istproducts/' + cmp_id, { headers: authHeader() });
};

const getCompanySuppliers = (cmp_id) => {
  return axios.get(API_URLU + 'company-istsuppliers/' + cmp_id, { headers: authHeader() });
};

const getProductDetails = (id) => {
  return axios.get(API_URLU + 'ist-products/' + id, { headers: authHeader() });
};

const getSupplierDetails = (id) => {
  return axios.get(API_URLU + 'ist-suppliers/' + id, { headers: authHeader() });
};

const getSupplerProductDetails = (id) => {
  return axios.get(API_URLU + 'ist-supplierProducts/' + id, { headers: authHeader() });
};

const getSupplierStocks = (supCode) => {
  return axios.get(API_URLU + 'company-istsupplierProducts/' + supCode, { headers: authHeader() });
};

const getCompanyStockCodes = (cmpId) => {
  return axios.get(API_URLU + 'company-stockcodes/' + cmpId, { headers: authHeader() });
};

const getCompanyStocks = (cmpId) => {
  return axios.get(API_URLU + 'company-stocks/' + cmpId, { headers: authHeader() });
};

const getQuoteId = (stockCode, pdate, cmpId, puser, cname, cphone, caddress, qtdId, quant) => {
  return axios.get(
    API_URLU +
    'qtn_id?stockCode=' +
    stockCode +
    '&pdate=' +
    pdate +
    '&cmpId=' +
    cmpId +
    '&puser=' +
    puser +
    '&clientName=' +
    cname +
    '&clientPhone=' +
    cphone +
    '&clientAddress=' +
    caddress +
    '&qtdId=' +
    qtdId +
    '&quantity=' +
    quant,
    { headers: authHeader() }
  );
};

const genCombinedQuote = (qhdId, cmpId, pdate, puser) => {
  return axios.get(API_URLU + 'gen-combinedQuote?qhdId=' + qhdId + '&cmpId=' + cmpId + '&pdate=' + pdate + '&user=' + puser, {
    headers: authHeader()
  });
};

const updateStockQuote = (stockCode, pdate, cmpId, puser) => {
  return axios.get(API_URLU + 'update-quote?stockCode=' + stockCode + '&pdate=' + pdate + '&cmpId=' + cmpId + '&user=' + puser, {
    headers: authHeader()
  });
};

const updatePriceList = (stockCode, pdate, cmpId) => {
  return axios.get(API_URLU + 'update-price?stockCode=' + stockCode + '&effDate=' + pdate + '&cmpId=' + cmpId, {
    headers: authHeader()
  });
};

const UpdateAllPrices = (pdate, cmpId) => {
  return axios.get(API_URLU + 'update-price-all?effDate=' + pdate + '&cmpId=' + cmpId, {
    headers: authHeader()
  });
};

const inteGrateWithKct = (cmpId) => {
  return axios.get(API_URLU + 'integrate-with-kct?cmpId=' + cmpId, {
    headers: authHeader()
  });
};

const getQuoteReport = (
  quoteId,
  repFormat,
  companyName,
  clientName,
  clientPhone,
  clientAddress,
  code,
  sname,
  dateOfQuote,
  repName,
  quantity,
  totalCashPrice,
  phyLocation,
  postalAddress,
  town,
  telephone,
  quoteIdz
) => {
  return axios.get(
    API_URLU +
    'pricequote-report?qtnId=' +
    quoteId +
    '&reportFormat=' +
    repFormat +
    '&companyName=' +
    companyName +
    '&clientName=' +
    clientName +
    '&clientPhone=' +
    clientPhone +
    '&clientAddress=' +
    clientAddress +
    '&stockCode=' +
    code +
    '&stockName=' +
    sname +
    '&quoteDate=' +
    dateOfQuote +
    '&repName=' +
    repName +
    '&quantity=' +
    quantity +
    '&totalCashPrice=' +
    totalCashPrice +
    '&phyLocation=' +
    phyLocation +
    '&postalAddress=' +
    postalAddress +
    '&town=' +
    town +
    '&telephone=' +
    telephone +
    '&nonStockCode=' +
    quoteIdz,
    { headers: authHeader() }
  );
};

const getCombQuoteReport = (
  quoteId,
  repFormat,
  companyName,
  clientName,
  clientPhone,
  clientAddress,
  code,
  sname,
  dateOfQuote,
  repName,
  quantity,
  totalCashPrice,
  phyLocation,
  postalAddress,
  town,
  telephone,
  quoteIdz
) => {
  return axios.get(
    API_URLU +
    'pricequote-report?qtnId=' +
    quoteId +
    '&reportFormat=' +
    repFormat +
    '&companyName=' +
    companyName +
    '&clientName=' +
    clientName +
    '&clientPhone=' +
    clientPhone +
    '&clientAddress=' +
    clientAddress +
    '&stockCode=' +
    code +
    '&stockName=' +
    sname +
    '&quoteDate=' +
    dateOfQuote +
    '&repName=' +
    repName +
    '&quantity=' +
    quantity +
    '&totalCashPrice=' +
    totalCashPrice +
    '&phyLocation=' +
    phyLocation +
    '&postalAddress=' +
    postalAddress +
    '&town=' +
    town +
    '&telephone=' +
    telephone +
    '&nonStockCode=' +
    quoteIdz,
    { headers: authHeader() }
  );
};

const getQuoteInfo = (id) => {
  return axios.get(API_URLU + 'price-quotation/' + id, { headers: authHeader() });
};
const delQuote = (user, id) => {
  return axios.get(API_URLU + 'archive-quote?user=' + user + '&qtnId=' + id, { headers: authHeader() });
};

const closePeriod = (id) => {
  return axios.get(API_URLU + 'close-period?periodId=' + id, { headers: authHeader() });
};

const archCombQuote = (user, id) => {
  return axios.get(API_URLU + 'archive-combQuote?user=' + user + '&qhdId=' + id, { headers: authHeader() });
};

const postQuoteHeader = (data) => {
  return axios.post(API_URLU + 'combined-quotation', data, { headers: authHeader() });
};

const postQuoteDetails = (data) => {
  return axios.post(API_URLU + 'quote-details', data, { headers: authHeader() });
};

const postVatRates = (data) => {
  return axios.post(API_URLU + 'vat-rates', data, { headers: authHeader() });
};

const postStandardRates = (data) => {
  return axios.post(API_URLU + 'standard-rates', data, { headers: authHeader() });
};

const postNewPeriod = (data) => {
  return axios.post(API_URLU + 'ist-periods', data, { headers: authHeader() });
};

const postGeneralRates = (data) => {
  return axios.post(API_URLU + 'general-rates', data, { headers: authHeader() });
};

const postIstProducts = (data) => {
  return axios.post(API_URLU + 'ist-products', data, { headers: authHeader() });
};

const postIstSuppliers = (data) => {
  return axios.post(API_URLU + 'ist-suppliers', data, { headers: authHeader() });
};

const putIstProducts = (id, data) => {
  return axios.put(API_URLU + 'ist-products/' + id, data, { headers: authHeader() });
};

const putIstSupplierProducts = (id, data) => {
  return axios.put(API_URLU + 'ist-supplierProducts/' + id, data, { headers: authHeader() });
};

const postIstSupplierProducts = (data) => {
  return axios.post(API_URLU + 'ist-supplierProducts', data, { headers: authHeader() });
};

const putCashRateDetails = (id, data) => {
  return axios.put(API_URLU + 'ist-cashRates/' + id, data, { headers: authHeader() });
};

const postCashRateDetails = (data) => {
  return axios.post(API_URLU + 'ist-cashRates', data, { headers: authHeader() });
};

const putHpDepositDetails = (id, data) => {
  return axios.put(API_URLU + 'ist-hpdepositPercs/' + id, data, { headers: authHeader() });
};

const postHpDepositDetails = (data) => {
  return axios.post(API_URLU + 'ist-hpdepositPercs', data, { headers: authHeader() });
};

const delHpDepositDetails = (id) => {
  return axios.delete(API_URLU + 'ist-hpdepositPercs/' + id, { headers: authHeader() });
};

const putMarkupDetails = (id, data) => {
  return axios.put(API_URLU + 'ist-checkOffMarkup/' + id, data, { headers: authHeader() });
};

const postMarkupDetails = (data) => {
  return axios.post(API_URLU + 'ist-checkOffMarkup', data, { headers: authHeader() });
};

const putDiscountDetails = (id, data) => {
  return axios.put(API_URLU + 'ist-hpdiscounts/' + id, data, { headers: authHeader() });
};

const postDiscountDetails = (data) => {
  return axios.post(API_URLU + 'ist-hpdiscounts', data, { headers: authHeader() });
};

const delDiscountDetails = (id) => {
  return axios.delete(API_URLU + 'ist-hpdiscounts/' + id, { headers: authHeader() });
};

const putInstalMonths = (id, data) => {
  return axios.put(API_URLU + 'ist-instalmonths/' + id, data, { headers: authHeader() });
};

const postInstalMonths = (data) => {
  return axios.post(API_URLU + 'ist-instalmonths', data, { headers: authHeader() });
};

const delInstalMonths = (id) => {
  return axios.delete(API_URLU + 'ist-instalmonths/' + id, { headers: authHeader() });
};

const putMarkupRates = (id, data) => {
  return axios.put(API_URLU + 'ist-hpmarkuprates/' + id, data, { headers: authHeader() });
};

const postMarkupRates = (data) => {
  return axios.post(API_URLU + 'ist-hpmarkuprates', data, { headers: authHeader() });
};

const delMarkupRate = (id) => {
  return axios.delete(API_URLU + 'ist-hpmarkuprates/' + id, { headers: authHeader() });
};

const putMarkupPercs = (id, data) => {
  return axios.put(API_URLU + 'ist-hpmarkuppercs/' + id, data, { headers: authHeader() });
};

const getCombinedQuotes = (qdtId) => {
  return axios.get(API_URLU + 'get-combinedQuotes/' + qdtId, { headers: authHeader() });
};

const listSingleQuoutes = () => {
  return axios.get(API_URLU + 'list-singleQuotes', { headers: authHeader() });
};

const listCombinedQuoutes = (cmpId) => {
  return axios.get(API_URLU + 'list-combinedQuotes/' + cmpId, { headers: authHeader() });
};

const companyVatRates = (cmpId) => {
  return axios.get(API_URLU + 'company-vats/' + cmpId, { headers: authHeader() });
};

const companyStdRates = (cmpId) => {
  return axios.get(API_URLU + 'company-standardRates/' + cmpId, { headers: authHeader() });
};

const companyGenRates = (cmpId) => {
  return axios.get(API_URLU + 'company-generalRates/' + cmpId, { headers: authHeader() });
};
const currentPeriods = (cmpId) => {
  return axios.get(API_URLU + 'company-currentperiods/' + cmpId, { headers: authHeader() });
};
const pastPeriods = (cmpId) => {
  return axios.get(API_URLU + 'company-pastperiods/' + cmpId, { headers: authHeader() });
};

const allPeriods = (cmpId) => {
  return axios.get(API_URLU + 'get-periods-vw?cmpId=' + cmpId, { headers: authHeader() });
};

const checkVatDates = (cmpId, startDate, endDate) => {
  return axios.get(API_URLU + 'check-vatDates?cmpId=' + cmpId + '&startDate=' + startDate + '&endDate=' + endDate, {
    headers: authHeader()
  });
};

const getCombinedSingle = (stockCode) => {
  return axios.get(API_URLU + 'combined-single?stockCode=' + stockCode, { headers: authHeader() });
};

const getCompanyTariffPeriods = (cmpId) => {
  return axios.get(API_URLU + 'tariff-periods?cmpId=' + cmpId, { headers: authHeader() });
};

const getTariffCashRates = (trpId) => {
  return axios.get(API_URLU + 'ist-trpCashRates/' + trpId, { headers: authHeader() });
};

const getCheckOffMarkupPercs = (trpId) => {
  return axios.get(API_URLU + 'ist-companyCheckOffMarkup/' + trpId, { headers: authHeader() });
};

const getTrpDiscounts = (trpId) => {
  return axios.get(API_URLU + 'ist-hpTrpdiscounts/' + trpId, { headers: authHeader() });
};

const getTrpInstalMonths = (trpId) => {
  return axios.get(API_URLU + 'ist-trpinstalmonths/' + trpId, { headers: authHeader() });
};

const getHpMarkupRates = (trpId) => {
  return axios.get(API_URLU + 'ist-trphpmarkuprates/' + trpId, { headers: authHeader() });
};

const getHpMarkupPercs = (trpId) => {
  return axios.get(API_URLU + 'ist-trphpmarkuppercs/' + trpId, { headers: authHeader() });
};

const getDiscountDetails = (id) => {
  return axios.get(API_URLU + 'ist-hpdiscounts/' + id, { headers: authHeader() });
};

const getInstalMonthsDetails = (id) => {
  return axios.get(API_URLU + 'ist-instalmonths/' + id, { headers: authHeader() });
};

const getRateDetails = (id) => {
  return axios.get(API_URLU + 'ist-cashRates/' + id, { headers: authHeader() });
};

const getHPDepositDetails = (id) => {
  return axios.get(API_URLU + 'ist-hpdepositPercs/' + id, { headers: authHeader() });
};

const getMarkupPercDetails = (id) => {
  return axios.get(API_URLU + 'ist-checkOffMarkup/' + id, { headers: authHeader() });
};

const closeTariffPeriod = (cmpId, pdate, user) => {
  return axios.get(API_URLU + 'close-tariffperiod?cmpId=' + cmpId + '&pdate=' + pdate + '&user=' + user, { headers: authHeader() });
};

const getTrpHpDeposit = (trpId) => {
  return axios.get(API_URLU + 'ist-hpTrpdepositPercs/' + trpId, { headers: authHeader() });
};

const getMarkupDetails = (rateId) => {
  return axios.get(API_URLU + 'ist-hpmarkuprates/' + rateId, { headers: authHeader() });
};

const getMarkupPerc = (rateId) => {
  return axios.get(API_URLU + 'ist-hpmarkuppercs/' + rateId, { headers: authHeader() });
};

const copyPeriods = (cmpId, trpId, pUser, pDate) => {
  return axios.get(API_URLU + 'copy-periods?cmpId=' + cmpId + '&trpId=' + trpId + '&pUser=' + pUser + '&pDate=' + pDate, {
    headers: authHeader()
  });
};

const getProductHist = (id) => {
  return axios.get(API_URLU + 'ist-productsHist/' + id, { headers: authHeader() });
};

const getPriceCataloq = (periodY) => {
  return axios.get(API_URLU + 'get-price-catalogue?periodYear=' + periodY, { headers: authHeader() });
};

const getStockCatalogue = (stockCode) => {
  return axios.get(API_URLU + 'get-stock-catalog?stockCode=' + stockCode, { headers: authHeader() });
};

const getCataloguePeriods = () => {
  return axios.get(API_URLU + 'get-catalog-periods', { headers: authHeader() });
};

const getJointYn = (stockCode, cmpId) => {
  return axios.get(API_URLU + 'is-jointStock?stockCode=' + stockCode + '&cmpId=' + cmpId, { headers: authHeader() });
};

const getJointStockCodes = (stockCode, cmpId) => {
  return axios.get(API_URLU + 'joint-stocks?stockCode=' + stockCode + '&cmpId=' + cmpId, { headers: authHeader() });
};

const getActiveStocks = (cmpId, pDate) => {
  return axios.get(API_URLU + 'active-stocks?cmpId=' + cmpId + '&pDate=' + pDate, { headers: authHeader() });
};

const getJointStocks = (cmpId, pDate, stockCode) => {
  return axios.get(API_URLU + 'attach-joint-stocks?cmpId=' + cmpId + '&pDate=' + pDate + '&stockCode=' + stockCode, {
    headers: authHeader()
  });
};

const addJointStocks = (cmpId, jointStockCode, stockCode, pAction) => {
  return axios.get(
    API_URLU + 'add-joint-stock?cmpId=' + cmpId + '&jointStockCode=' + jointStockCode + '&stockCode=' + stockCode + '&pAction=' + pAction,
    { headers: authHeader() }
  );
};

const getMinDate = (cmpId) => {
  return axios.get(API_URLU + 'min-date?cmpId=' + cmpId, { headers: authHeader() });
};

const getStockCheckOff = (stockCode) => {
  return axios.get(API_URLU + 'stock-checkoff?stockCode=' + stockCode, { headers: authHeader() });
};

const getSupplierPriceList = (cmpId, supCode) => {
  return axios.get(API_URLU + 'supplier-price-list?cmpId=' + cmpId + '&supCode=' + supCode, { headers: authHeader() });
};

const getSupplierPastPriceList = (cmpId, supCode, stockCode) => {
  return axios.get(API_URLU + 'supplier-pastprice-list?cmpId=' + cmpId + '&supCode=' + supCode + '&stockCode=' + stockCode, {
    headers: authHeader()
  });
};

const updatePriceCatalogue = (data) => {
  return axios.get(
    API_URLU +
    'update-price-catalogue?periodYear=' +
    data.periodYear +
    '&periodMonth=' +
    data.periodMonth +
    '&pDate=' +
    data.pDate +
    '&cmpId=' +
    data.cmpId +
    '&username=' +
    data.username,
    {
      headers: authHeader()
    }
  );
};

const addNewPriceListItem = (data) => {
  return axios.get(
    API_URLU +
    'add-new-stock-pricelist?cmpId=' +
    data.cmpId +
    '&stockCode=' +
    data.stockCode +
    '&pDate=' +
    data.pDate +
    '&combinedSingle=' +
    data.combinedSingle +
    '&pUser=' +
    data.pUser,
    {
      headers: authHeader()
    }
  );
};

const approveVATRates = (data) => {
  return axios.get(
    API_URLU +
    'approve-vat?approvedYN=' +
    data.approvedYN +
    '&approvedBy=' +
    data.approvedBy +
    '&approvedDate=' +
    data.approvedDate +
    '&id=' +
    data.id,
    {
      headers: authHeader()
    }
  );
};

const approveSTDRates = (data) => {
  return axios.get(
    API_URLU +
    'approve-std?approvedYN=' +
    data.approvedYN +
    '&approvedBy=' +
    data.approvedBy +
    '&approvedDate=' +
    data.approvedDate +
    '&id=' +
    data.id,
    {
      headers: authHeader()
    }
  );
};

const approveGENRates = (data) => {
  return axios.get(
    API_URLU +
    'approve-gen?approvedYN=' +
    data.approvedYN +
    '&approvedBy=' +
    data.approvedBy +
    '&approvedDate=' +
    data.approvedDate +
    '&id=' +
    data.id,
    {
      headers: authHeader()
    }
  );
};

const approvePeriod = (data) => {
  return axios.get(
    API_URLU +
    'approve-period?approvedYN=' +
    data.approvedYN +
    '&approvedBy=' +
    data.approvedBy +
    '&approvedDate=' +
    data.approvedDate +
    '&id=' +
    data.id,
    {
      headers: authHeader()
    }
  );
};

const approveStock = (data) => {
  return axios.get(
    API_URLU +
    'approve-stock?approvedYN=' +
    data.approvedYN +
    '&approvedBy=' +
    data.approvedBy +
    '&approvedDate=' +
    data.approvedDate +
    '&id=' +
    data.id +
    '&cmpId=' +
    data.cmpId,
    {
      headers: authHeader()
    }
  );
};

const clearStockPrices = (data) => {
  return axios.get(API_URLU + 'clear-stock-prices?periodYear=' + data.periodY + '&periodMonth=' + data.periodM, {
    headers: authHeader()
  });
};

const updateStockPrices = (data) => {
  return axios.get(API_URLU + 'update-stock-prices?cmpId=' + data.cmpId + '&periodYear=' + data.periodY + '&periodMonth=' + data.periodM, {
    headers: authHeader()
  });
};

const updateTariffPeriod = (data) => {
  return axios.get(API_URLU + 'update-tariff-period?id=' + data.id + '&startdate=' + data.startdate + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const approvetariffPeriod = (data) => {
  return axios.get(API_URLU + 'approve-tariff-period-proc?id=' + data.id + '&username=' + data.username + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const approveCashRate = (data) => {
  return axios.get(API_URLU + 'approve-cashrate?rateId=' + data.id + '&pUser=' + data.username, {
    headers: authHeader()
  });
};

const approveCheckOff = (data) => {
  return axios.get(API_URLU + 'approve-checkoff?rateId=' + data.id + '&pUser=' + data.username, {
    headers: authHeader()
  });
};

const genCombQuoteHeader = (data) => {
  return axios.get(
    API_URLU +
    'gen-comb-non-stock-header?cmpId=' +
    data.cmpId +
    '&supName=' +
    data.supName +
    '&user=' +
    data.user +
    '&quoteDate=' +
    data.quoteDate +
    '&weight=' +
    data.weight +
    '&solarPanel=' +
    data.solarPanel +
    '&solarComponent=' +
    data.solarComponent +
    '&discountPerc=' +
    data.discountPerc +
    '&stockName=' +
    data.stockName,
    {
      headers: authHeader()
    }
  );
};
const genCombQuoteNoneStockDetails = (data) => {
  return axios.get(
    API_URLU +
    'gen-comb-non-stock-details?cmpId=' +
    data.cmpId +
    '&csqId=' +
    data.csqId +
    '&stockName=' +
    data.stockName +
    '&supplierPrice=' +
    data.supplierPrice +
    '&vatableYn=' +
    data.vatableYn +
    '&vatRate=' +
    data.vatRate +
    '&createdBy=' +
    data.createdBy,
    {
      headers: authHeader()
    }
  );
};
const genNoneStockQuote = (data) => {
  return axios.get(
    API_URLU +
    'none-stock-quote?stockName=' +
    data.stockName +
    '&supplierName=' +
    data.supplierName +
    '&weight=' +
    data.weight +
    '&supplierPrice=' +
    data.supplierPrice +
    '&saleVatRate=' +
    data.saleVatRate +
    '&discountPerc=' +
    data.discountPerc +
    '&solarPanelYn=' +
    data.solarPanelYn +
    '&solarComponentYn=' +
    data.solarComponentYn +
    '&pDate=' +
    data.pDate +
    '&cmpId=' +
    data.cmpId +
    '&username=' +
    data.username,
    {
      headers: authHeader()
    }
  );
};

const genCombNoneStockQuote = (data) => {
  return axios.get(
    API_URLU +
    'gen-comb-non-stock-quote?stockName=' +
    data.stockName +
    '&supplierName=' +
    data.supplierName +
    '&weight=' +
    data.weight +
    '&supplierPrice=' +
    data.supplierPrice +
    '&saleVatRate=' +
    data.saleVatRate +
    '&discountPerc=' +
    data.discountPerc +
    '&solarPanelYn=' +
    data.solarPanelYn +
    '&solarComponentYn=' +
    data.solarComponentYn +
    '&pDate=' +
    data.pDate +
    '&cmpId=' +
    data.cmpId +
    '&username=' +
    data.username +
    '&csqId=' +
    data.csqId,
    {
      headers: authHeader()
    }
  );
};

const listNonStockQuotes = (id) => {
  return axios.get(API_URLU + 'get-none-stock-quotes?nonStockCode=' + id, { headers: authHeader() });
};

const listCombNonStockQuotes = (id) => {
  return axios.get(API_URLU + 'get-comb-none-stock-quotes?csqId=' + id, { headers: authHeader() });
};

const getActiveEndDate = (cmpId) => {
  return axios.get(API_URLU + 'active_enddate?cmpId=' + cmpId, { headers: authHeader() });
};

const getMenuLevels = (data) => {
  return axios.get(API_URLU + 'get-menusbk?sstId=' + data.sstId + '&accessId=' + data.accessId + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const getAddTempItem = (id) => {
  return axios.get(API_URLU + 'add-temp-stock?stockCode=' + id, {
    headers: authHeader()
  });
};

const getPoH = () => {
  return axios.get(API_URLU + 'po-headers', { headers: authHeader() });
};

const getPoHVW = (data) => {
  return axios.get(API_URLU + 'po-headervw?cmpId=' + data.cmpId + '&userId=' + data.userId + '&approvalStatus=' + data.approvalStatus, {
    headers: authHeader()
  });
};

const getReqH = (data) => {
  return axios.get(API_URLU + 'req-headersvw?userId=' + data.userId + '&cmpId=' + data.cmpId, { headers: authHeader() });
};

const getPoD = (id) => {
  return axios.get(API_URLU + 'po-details-vw?phdId=' + id, { headers: authHeader() });
};

const getReqD = (id) => {
  return axios.get(API_URLU + 'req-details-vw?rqhId=' + id, { headers: authHeader() });
};

const getPolNo = (data) => {
  return axios.get(
    API_URLU +
    'getPolnumber?cmpId=' +
    data.cmpId +
    '&transType=' +
    data.transType +
    '&branchCode=' +
    data.branchCode +
    '&transDate=' +
    data.transDate,
    { headers: authHeader() }
  );
};

const postPoH = (data) => {
  return axios.post(API_URLU + 'po-headers', data, { headers: authHeader() });
};

const postPoD = (data) => {
  return axios.post(API_URLU + 'po-details', data, { headers: authHeader() });
};

const getReqSummary = (data) => {
  return axios.get(API_URLU + 'requisition-summary/' + data.year + '/' + data.usrId, { headers: authHeader() });
};

const getPoSummary = (data) => {
  return axios.get(API_URLU + 'po-summary/' + data.year + '/' + data.usrId, { headers: authHeader() });
};

const getPohApproval = (data) => {
  return axios.get(
    API_URLU +
    'approve-poh?username=' +
    data.username +
    '&approvedDate=' +
    data.approvedDate +
    '&phdId=' +
    data.phdId +
    '&cmpId=' +
    data.cmpId +
    '&approvalStatus=' +
    data.approvalStatus,
    { headers: authHeader() }
  );
};

const updateMialSent = (data) => {
  return axios.get(API_URLU + 'approve-poh-mail?phdId=' + data.phdId + '&cmpId=' + data.cmpId, { headers: authHeader() });
};

const cancelPO = (data) => {
  return axios.get(
    API_URLU +
    'cancel-poh?phdId=' +
    data.phdId +
    '&cmpId=' +
    data.cmpId +
    '&cancellationReason=' +
    data.cancellationReason +
    '&username=' +
    data.username +
    '&cancelledDate=' +
    data.cancelledDate,
    { headers: authHeader() }
  );
};

const getPurchaseReport = (data) => {
  return axios.get(
    API_URLU +
    'purchase-report?reportFormat=' +
    data.reportFormat +
    '&repName=' +
    data.repName +
    '&cmpId=' +
    data.cmpId +
    '&phdId=' +
    data.phdId +
    '&approvedBy=' +
    data.approvedBy +
    '&vendor=' +
    data.vendor +
    '&poNumber=' +
    data.poNumber +
    '&poDate=' +
    data.poDate +
    '&shop=' +
    data.shop +
    '&dispatchCode=' +
    data.dispatchCode +
    '&signUrl=' +
    data.signUrl +
    '&oldOrderNumber=' +
    data.oldOrderNumber,
    {
      headers: authHeader()
    }
  );
};

const postGaaH = (data) => {
  return axios.post(API_URLU + 'gaa-headers', data, { headers: authHeader() });
};

const postGaaD = (data) => {
  return axios.post(API_URLU + 'gaa-details', data, { headers: authHeader() });
};

const getGaaDByGaaNo = (id) => {
  return axios.get(API_URLU + 'gaa-details-gaaNo?gaaNo=' + id, { headers: authHeader() });
};

const getUpdatePoDetails = (data) => {
  return axios.get(
    API_URLU +
    'approve-pod?rqdId=' +
    data.rqdId +
    '&cmpId=' +
    data.cmpId +
    '&quantityApproved=' +
    data.quantityApproved +
    '&approvalComments=' +
    data.approvalComments +
    '&approvalStatus=' +
    data.approvalStatus +
    '&username=' +
    data.username +
    '&approvedDate=' +
    data.approvedDate,
    {
      headers: authHeader()
    }
  );
};

const getPoNotInGaa = (data) => {
  return axios.get(
    API_URLU + 'po-notin-gaa-headervw?cmpId=' + data.cmpId + '&userId=' + data.userId + '&approvalStatus=' + data.approvalStatus,
    {
      headers: authHeader()
    }
  );
};

const getGaaHVW = (data) => {
  return axios.get(API_URLU + 'gaa-headervw?cmpId=' + data.cmpId + '&userId=' + data.userId, {
    headers: authHeader()
  });
};

const getGaaHVWItems = (data) => {
  return axios.get(API_URLU + 'gaa-headervw-items?cmpId=' + data.cmpId + '&userId=' + data.userId + '&poNumber=' + data.poNumber, {
    headers: authHeader()
  });
};

const getUserBranches = (id, id2) => {
  return axios.get(API_URLU + 'get-user_branches?cmpId=' + id + '&userId=' + id2, {
    headers: authHeader()
  });
};

const postGap = (data) => {
  return axios.post(API_URLU + 'gaa-particulars', data, { headers: authHeader() });
};

const getGapItemsByGaaNo = (id) => {
  return axios.get(API_URLU + 'gaa-particulars-gaaNo?gaaNo=' + id, { headers: authHeader() });
};

const postStkTransH = (data) => {
  return axios.post(API_URLU + 'stock-trans-header', data, { headers: authHeader() });
};

const postStkTransD = (data) => {
  return axios.post(API_URLU + 'stock-trans-details', data, { headers: authHeader() });
};

const generateCombinedNonStockQuote = (csqId, user) => {
  return axios.get(API_URLU + 'generate-combined-nonstock-quote?csqId=' + csqId + '&user=' + user, { headers: authHeader() });
};

const getShopTransfers = (data) => {
  return axios.get(
    API_URLU + 'shop-trans-headervw?cmpId=' + data.cmpId + '&userId=' + data.userId + '&approvalStatus=' + data.approvalStatus,
    {
      headers: authHeader()
    }
  );
};

const getShopTransferDetails = (data) => {
  return axios.get(API_URLU + 'shop-trans-detailvw?cmpId=' + data.cmpId + '&sthId=' + data.sthId, {
    headers: authHeader()
  });
};

const getTransferInvoiceReport = (data) => {
  return axios.get(
    API_URLU +
    'transfer-invoice-report?reportFormat=' +
    data.reportFormat +
    '&repName=' +
    data.repName +
    '&cmpId=' +
    data.cmpId +
    '&phdId=' +
    data.phdId +
    '&approvedBy=' +
    data.approvedBy +
    '&vendor=' +
    data.vendor +
    '&poNumber=' +
    data.poNumber +
    '&poDate=' +
    data.poDate +
    '&shop=' +
    data.shop +
    '&Collected_by=' +
    data.Collected_by +
    '&Dispatcher=' +
    data.Dispatcher +
    '&url=' +
    data.url +
    '&oldOrderNumber=' +
    data.oldOrderNumber,
    {
      headers: authHeader()
    }
  );
};

const getSupplierEmail = (data) => {
  return axios.get(API_URLU + 'supplier-emails?supplierCode=' + data.supplierCode + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const sendLpoMail = (data) => {
  return axios.get(API_URLU + 'send-lpo-email?email=' + data.email + '&repName=' + data.repName, {
    headers: authHeader()
  });
};

const saleItems = (data) => {
  return axios.get(API_URLU + 'get-sale-items?cmpId=' + data.cmpId + '&branchCode=' + data.branchCode, {
    headers: authHeader()
  });
};

const postSalesHeader = (data) => {
  return axios.post(API_URLU + 'sale-header', data, { headers: authHeader() });
};

const postSalesDetails = (data) => {
  return axios.post(API_URLU + 'sale-details', data, { headers: authHeader() });
};

const getSalesDetailsBySshId = (id) => {
  return axios.get(API_URLU + 'sale-details-ssh?sshId=' + id, { headers: authHeader() });
};

const postSalesParticular = (data) => {
  return axios.post(API_URLU + 'sale-particulars', data, { headers: authHeader() });
};

const getSalesParticularBySshId = (id) => {
  return axios.get(API_URLU + 'sale-particulars-ssh?sshId=' + id, { headers: authHeader() });
};

const getSalesHeader = (id) => {
  return axios.get(API_URLU + 'cmp-sale-header?cmpId=' + id, { headers: authHeader() });
};

const getReceiptTranCodes = (cmpId) => {
  return axios.get(API_URLU + 'receipt-codes/' + cmpId, { headers: authHeader() });
};

const findPaymentModes = () => {
  return axios.get(API_URLU + 'payment-modes', { headers: authHeader() });
};
const getCustomerCodes = () => {
  return axios.get(API_URLU + 'customer-codes', { headers: authHeader() });
};

const getPolicyInformation = (custCode) => {
  return axios.get(API_URLU + 'policy-information/' + custCode, { headers: authHeader() });
};

const getAddress = (clientNumber) => {
  return axios.get(API_URLU + 'client-address/' + clientNumber, { headers: authHeader() });
};

const getAllBankAccounts = (cmpId) => {
  return axios.get(API_URLU + 'company-accounts/' + cmpId, { headers: authHeader() });
};

const getAllCreditAccounts = (cmpId) => {
  return axios.get(API_URLU + 'credit-accounts/' + cmpId, { headers: authHeader() });
};

const getLinkedCustomerAccounts = (cmpId, custCode) => {
  return axios.get(API_URLU + 'linked-customer-accounts/' + cmpId + '/' + custCode, { headers: authHeader() });
};

const getCustomerSubaccounts = (cmpId, custCode) => {
  return axios.get(API_URLU + 'get-customer-subaccount/' + cmpId + '/' + custCode, { headers: authHeader() });
};

const getDocDetails = (cmpId, tranCode, docDate, auto) => {
  return axios.get(API_URLU + 'doc_number?cmpId=' + cmpId + '&trancode=' + tranCode + '&docdate=' + docDate + '&auto=' + auto, {
    headers: authHeader()
  });
};

const docAvailable = (data) => {
  return axios.get(
    API_URLU +
    'is-doc-number-available?accountYear=' +
    data.accountYear +
    '&tranCode=' +
    data.tranCode +
    '&docNumber=' +
    data.docNumber +
    '&cmpId=' +
    data.cmpId,
    { headers: authHeader() }
  );
};

// const postReceiptHeader = (data) => {
//   return axios.post(API_URLU + 'receipt', data, { headers: authHeader() });
// };

// const putReceiptHeader = (id, data) => {
//   return axios.put(API_URLU + 'receipt/' + id, data, { headers: authHeader() });
// };

// const postReceiptDetails = (data) => {
//   return axios.post(API_URLU + 'receipt-details', data, { headers: authHeader() });
// };

// const putReceiptDetails = (id, data) => {
//   return axios.put(API_URLU + 'receipt-details/' + id, data, { headers: authHeader() });
// };

// const getReceiptDetails = (id) => {
//   return axios.get(API_URLU + 'receipt-details/' + id, { headers: authHeader() });
// };

const getCompanyBanks = (cmpId) => {
  return axios.get(API_URLU + 'customer-banks/' + cmpId, { headers: authHeader() });
};

const getReceiptHeaderApprovalStatus = (cmpId, rhdId) => {
  return axios.get(API_URLU + 'is-header-approved/' + cmpId + '/' + rhdId, { headers: authHeader() });
};

// const approveReceiptHeader = (cmpId, rhdId, docDate) => {
//   return axios.get(API_URLU + 'approve-receipt-header/' + cmpId + '/' + rhdId + '/' + docDate, { headers: authHeader() });
// };

const poReports = (id) => {
  return axios.get(API_URLU + 'po-reports?cmpId=' + id, { headers: authHeader() });
};

const getPoReportDetails = (data) => {
  return axios.get(
    API_URLU + 'po-report-details?cmpId=' + data.cmpId + '&userId=' + data.userId + '&approvalStatus=' + data.approvalStatus,
    {
      headers: authHeader()
    }
  );
};

const getPurchaseReport2 = (data) => {
  return axios.get(
    API_URLU +
    'purchase-report?reportFormat=' +
    data.reportFormat +
    '&repName=' +
    data.repName +
    '&cmpId=' +
    data.cmpId +
    '&userId=' +
    data.userId,
    {
      headers: authHeader()
    }
  );
};

const getSaleTypes = (id) => {
  return axios.get(API_URLU + 'get-sale-type?cmpId=' + id, {
    headers: authHeader()
  });
};

const companyReceipts = (cmpId) => {
  return axios.get(API_URLU + 'get-company-receipts/' + cmpId, { headers: authHeader() });
};

const getSelectedReceiptDetails = (id) => {
  return axios.get(API_URLU + 'get-receipt-by-rhdid/' + id, { headers: authHeader() });
};

const getPaymentHeaders = (data) => {
  return axios.get(API_URLU + "cfspaymentheaders-vw?cmpId=" + data.cmpId + '&startDate=' + data.startDate + '&endDate=' + data.endDate, {
    headers: authHeader(),
  });
};

const getPaymentDetails = () => {
  return axios.get(API_URLU + 'payment-details', { headers: authHeader() });
};

const getPaymentHeaderByHeaderId = (phdId) => {
  return axios.get(API_URLU + 'payment-headers/' + phdId, {
    headers: authHeader()
  });
};

const getAllPaymentHeaders = () => {
  return axios.get(API_URLU + 'payment-headers', { headers: authHeader() });
};

const postPaymentHeaders = (data) => {
  return axios.post(API_URLU + 'payment-headers', data, { headers: authHeader() });
};

const postGltranHeaders = (data) => {
  return axios.post(API_URLU + 'gltran-headers', data, { headers: authHeader() });
};

const postGltranDetails = (data) => {
  return axios.post(API_URLU + 'gltran-details', data, { headers: authHeader() });
};

const putPaymentHeaders = (phdId, data) => {
  return axios.put(API_URLU + 'payment-headers/' + phdId, data, { headers: authHeader() });
};

const postPaymentDetails = (data) => {
  return axios.post(API_URLU + 'payment-details', data, { headers: authHeader() });
};

const getInvoiceHeaders = (data) => {
  return axios.get(API_URLU + "cfsinvoiceheaders-vw?cmpId=" + data.cmpId + '&startDate=' + data.startDate + '&endDate=' + data.endDate, {
    headers: authHeader(),
  });
};

const getInvoiceTransactionCodes = () => {
  return axios.get(API_URLU + 'cfsinvoice-codes', { headers: authHeader() });
};

const getPaymentTransactionCodes = () => {
  return axios.get(API_URLU + 'cfspayment-codes', { headers: authHeader() });
};

const getPaymentModes = () => {
  return axios.get(API_URLU + 'cfspayment-modes', { headers: authHeader() });
};

const getOurRef = () => {
  return axios.get(API_URLU + 'cfspayments-ourref', { headers: authHeader() });
};

const getMainAccounts = () => {
  return axios.get(API_URLU + 'cfsmain-acc', { headers: authHeader() });
};

const getSubAccountsByMain = (data) => {
  return axios.get(API_URLU + 'cfssub-acc?accountCode=' + data.accountCode + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const getCustBank = (data) => {
  return axios.get(API_URLU + 'cfs-custbanks?cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const getBranches = () => {
  return axios.get(API_URLU + 'branch', { headers: authHeader() });
};

const getDepartments = () => {
  return axios.get(API_URLU + 'get-departments', { headers: authHeader() });
};

const getPaymentReport = (data) => {
  return axios.get(
    API_URLU +
    'purchase-report?reportFormat=' +
    data.reportFormat +
    '&repName=' +
    data.repName +
    '&cmpId=' +
    data.cmpId +
    '&phdId=' +
    data.phdId,
    {
      headers: authHeader()
    }
  );
};

const approvePaymentHeader = (data) => {
  return axios.get(
    API_URLU +
    'approve-payment-header?invoicePhdId=' +
    data.invoicePhdId +
    '&phdID=' +
    data.phdID +
    '&docDate=' +
    data.docDate +
    '&cmpId=' +
    data.cmpId +
    '&user=' +
    data.user +
    '&tranCode=' +
    data.tranCode +
    '&lcAmount=' +
    data.lcAmount +
    '&action=' +
    data.action,
    { headers: authHeader() }
  );
};

const getPaymentDocNumber = (data) => {
  return axios.get(
    API_URLU +
    'get-payment-doc-number?cmpId=' +
    data.cmpId +
    '&tranCode=' +
    data.tranCode +
    '&docDate=' +
    data.docDate +
    '&accountYear=' +
    data.accountYear,
    { headers: authHeader() }
  );
};

const getInvoiceBalance = (data) => {
  return axios.get(API_URLU + 'get-invoice-balance?phdId=' + data.phdId, {
    headers: authHeader()
  });
};

const getTranTypes = (cmpId) => {
  return axios.get(API_URLU + 'get-tran-types?cmpId=' + cmpId, { headers: authHeader() });
};
const getSaleFinTrans = (data) => {
  return axios.get(API_URLU + 'cmp-sale-fin-trans?sshId=' + data.sshId + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const genSaleFinTrans = (data) => {
  return axios.get(
    API_URLU +
    'gen-sale-fin-trans?sshId=' +
    data.sshId +
    '&cmpId=' +
    data.cmpId +
    '&saleDate=' +
    data.saleDate +
    '&username=' +
    data.username,

    {
      headers: authHeader()
    }
  );
};

const linkCustomerAccount = (data) => {
  return axios.get(API_URLU + 'link-debtor-subaccount?custCode=' + data.custCode + '&user=' + data.user + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const generateCustomerSubaccount = (data) => {
  return axios.get(API_URLU + 'generate-customer-subaccout?cmpId=' + data.cmpId + '&custCode=' + data.custCode + '&user=' + data.user, {
    headers: authHeader()
  });
};

const getUnbankedReceipts = (cmpId) => {
  return axios.get(API_URLU + 'get-unbanked-receipts?cmpId=' + cmpId, { headers: authHeader() });
};

const getBankingTranCode = (cmpId) => {
  return axios.get(API_URLU + 'get-banking-trancode/' + cmpId, { headers: authHeader() });
};
const getBankingDocNumber = (data) => {
  return axios.get(API_URLU + 'get-banking-doc-number?tranCode=' + data.tranCode + '&docDate=' + data.docDate + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const postReceiptBankHeader = (data) => {
  return axios.post(API_URLU + 'bank-receipt-header', data, { headers: authHeader() });
};

const postReceiptBankDetails = (data) => {
  return axios.post(API_URLU + 'receipt-banking-details', data, { headers: authHeader() });
};

const getUpdate = (data) => {
  return axios.get(
    API_URLU +
    'update-user-rights?approve=' +
    data.approve +
    '&initiate=' +
    data.initiate +
    '&sstId=' +
    data.sstId +
    '&username=' +
    data.username,
    {
      headers: authHeader()
    }
  );
};
const updateCompSystems = (data) => {
  return axios.get(
    API_URLU +
    'update-comp-system?cmpId=' +
    data.cmpId +
    '&sstId=' +
    data.sstId +
    '&username=' +
    data.createdBy +
    '&createdDate=' +
    data.createdDate,
    { headers: authHeader() }
  );
};

const getUserAllSubSystems = (data) => {
  return axios.get(API_URLU + 'user-all-sub-systems?cmpId=' + data.cmpId + '&username=' + data.username, {
    headers: authHeader()
  });
};

const getUserUnsubscribedSystems = (data) => {
  return axios.get(
    API_URLU +
    "user-unsubscribed-systems?cmpId=" +
    data.cmpId +
    "&username=" +
    data.username,
    { headers: authHeader() }
  );
};

const getCompUSystems = (id) => {
  return axios.get(API_URLU + "company-unsubscribed-systems?cmpId=" + id, {
    headers: authHeader(),
  });
};

const deleteUserComp = (id) => {
  return axios.delete(API_URLU + "ucompany/" + id, { headers: authHeader() });
};

const updateUserComp = (data) => {
  return axios.get(
    API_URLU +
    "update-comp-user?ucmId=" +
    data.ucmId +
    "&adminYN=" +
    data.adminYN,
    { headers: authHeader() }
  );
};

const getUserBycmp = (id) => {
  return axios.get(API_URLU + "company-users?cmpId=" + id, {
    headers: authHeader(),
  });
};

const getMasterUserComp = (id) => {
  return axios.get(API_URLU + "master-user-companies?userId=" + id, {
    headers: authHeader(),
  });
};

const getUserByName = (username) => {
  return axios.get(API_URLU + "userName/" + username, {
    headers: authHeader(),
  });
};


const getGeneralSettingsByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'gen-settings-id/' + cmpId, {
    headers: authHeader()
  });
};

const getSacMembers = (cmpId) => {
  return axios.get(API_URLU + 'sac-members-id/' + cmpId, {
    headers: authHeader()
  });
};

const getSacMembersById = (memberSysId) => {
  return axios.get(API_URLU + 'sac-members-sysId/' + memberSysId, {
    headers: authHeader()
  });
};

const getProvLoansById = (splId) => {
  return axios.get(API_URLU + 'prov-loans-id/' + splId, {
    headers: authHeader()
  });
};

const getApprLoansById = (salId) => {
  return axios.get(API_URLU + 'appr-loans-id/' + salId, {
    headers: authHeader()
  });
};


const postSacMembers = async (data) => {
  try {
    const response = await axios.post(API_URLU + 'sac-members', data, { headers: authHeader() });
    return response.data;
  } catch (error) {
    if (error.response) {
      const { status, data } = error.response;

      if (status === 409 && data.error === 'duplicate_key') {
        throw new Error(data.message || 'Email already exists in this sacco.');
      }

      if (status === 400 && data.error === 'data_integrity_violation') {
        throw new Error(data.message || 'Data integrity violation occurred.');
      }

      if (status === 500 && data.error === 'internal_server_error') {
        throw new Error(data.message || 'An unexpected error occurred.');
      }
    }
    throw new Error('An error occurred. Please try again.');
  }
};


const putSacMembers = (memberSysId, data) => {
  return axios.put(API_URLU + 'sac-members/' + memberSysId, data, { headers: authHeader() });
};

const getMemberCode = (data) => {
  return axios.get(
    API_URLU +
    'get-mem-code?cmpId=' +
    data.cmpId,
    { headers: authHeader() }
  );
};

const getBatchNumber = (data) => {
  return axios.get(
    API_URLU +
    'get-batch-number?cmpId=' +
    data.cmpId,
    { headers: authHeader() }
  );
};

const updateHeaderTotals = (data) => {
  return axios.get(
    API_URLU +
    'update-header-amount?sahSystemId=' +
    data.sahSystemId,
    { headers: authHeader() }
  );
};

const genSacSerials = (data) => {
  return axios.get(
    API_URLU +
    'gen-sac-serials?cmpId=' +
    data.cmpId,
    { headers: authHeader() }
  );
};

const usersPreSelfService = (data) => {
  return axios.get(
    API_URLU + 'users-pre-selfservice?cmpId=' + data.cmpId + '&user=' + data.user + '&module=' + data.module, { headers: authHeader() });
};

const companySystemLink = (data) => {
  return axios.get(
    API_URLU + 'company-system-link?cmpId=' + data.cmpId + '&sstId=' + data.sstId + '&email=' + data.email, { headers: authHeader() });
};

const adminSystemLink = (data) => {
  return axios.get(
    API_URLU + 'admin-system-link?cmpId=' + data.cmpId + '&sstId=' + data.sstId + '&usrId=' + data.usrId + '&email=' + data.email, { headers: authHeader() });
};

const putGeneralSettings = (cmpId, data) => {
  return axios.put(API_URLU + 'gen-settings/' + cmpId, data, { headers: authHeader() });
};

const getLoanTypes = (cmpId) => {
  return axios.get(API_URLU + 'loan-types/' + cmpId, {
    headers: authHeader()
  });
};

const getContributionTypes = (cmpId) => {
  return axios.get(API_URLU + 'contribution-types/' + cmpId, {
    headers: authHeader()
  });
};

const getChargeTypes = (cmpId) => {
  return axios.get(API_URLU + 'charge-types/' + cmpId, {
    headers: authHeader()
  });
};

const postLoanTypes = (data) => {
  return axios.post(API_URLU + 'loan-types', data, { headers: authHeader() });
};

const postShareTypes = (data) => {
  return axios.post(API_URLU + 'contribution-types', data, { headers: authHeader() });
};

const postChargeTypes = (data) => {
  return axios.post(API_URLU + 'charge-types', data, { headers: authHeader() });
};

const getLoanTypesById = (sysLoanTypeId) => {
  return axios.get(API_URLU + 'loan-types-id/' + sysLoanTypeId, {
    headers: authHeader()
  });
};

const getShareTypesById = (sysContribId) => {
  return axios.get(API_URLU + 'contribution-types-id/' + sysContribId, {
    headers: authHeader()
  });
};

const getChargeTypesById = (sysChrgId) => {
  return axios.get(API_URLU + 'charge-types-id/' + sysChrgId, {
    headers: authHeader()
  });
};

const putLoanTypes = (sysLoanTypeId, data) => {
  return axios.put(API_URLU + 'loan-types/' + sysLoanTypeId, data, { headers: authHeader() });
};

const putShareTypes = (sysContribId, data) => {
  return axios.put(API_URLU + 'contribution-types/' + sysContribId, data, { headers: authHeader() });
};
const putChargeTypes = (sysChrgId, data) => {
  return axios.put(API_URLU + 'charge-types/' + sysChrgId, data, { headers: authHeader() });
};

const delLoanType = (sysLoanTypeId) => {
  return axios.delete(API_URLU + 'loan-types/' + sysLoanTypeId, { headers: authHeader() });
};

const delShareTypes = (sysContribId) => {
  return axios.delete(API_URLU + 'contribution-types/' + sysContribId, { headers: authHeader() });
};

const delChargeTypes = (sysChrgId) => {
  return axios.delete(API_URLU + 'charge-types/' + sysChrgId, { headers: authHeader() });
};

const getSaccoControlsByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'sac-controls/' + cmpId, {
    headers: authHeader()
  });
};

const putSaccoControls = (sysCtrlId, data) => {
  return axios.put(API_URLU + 'sac-controls/' + sysCtrlId, data, { headers: authHeader() });
};

const getSacMembersByEmailandCmpId = (email, cmpId) => {
  return axios.get(API_URLU + 'sac-members-email-cmpid/' + email + '/' + cmpId, {
    headers: authHeader()
  });
};

const getSacMembersByEmail = (email) => {
  return axios.get(API_URLU + 'sac-members-email/' + email, {
    headers: authHeader()
  });
};

const getPendingMemApplications = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'pending-mem-applications/' + cmpId + '/' + memberCode, {
    headers: authHeader(),
  });
};

const getApprovedMemApplications = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'approved-mem-applications/' + cmpId + '/' + memberCode, {
    headers: authHeader()
  });
};

const getRejectedMemApplications = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'rejected-mem-applications/' + cmpId + '/' + memberCode, {
    headers: authHeader()
  });
};

const getCompletedMemApplications = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'completed-mem-applications/' + cmpId + '/' + memberCode, {
    headers: authHeader()
  });
};

const getSacLoanGuarantors = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'sac-loan-guarantorsvw/' + cmpId + '/' + memberCode, {
    headers: authHeader()
  });
};

const getPendingSaccoApplications = (cmpId) => {
  return axios.get(API_URLU + 'pending-applications/' + cmpId, {
    headers: authHeader(),
  });
};

const getApprovedSaccoApplications = (cmpId) => {
  return axios.get(API_URLU + 'approved-applications/' + cmpId, {
    headers: authHeader()
  });
};

const getRejectedSaccoApplications = (cmpId) => {
  return axios.get(API_URLU + 'rejected-applications/' + cmpId, {
    headers: authHeader()
  });
};

const getCompletedSaccoApplications = (cmpId) => {
  return axios.get(API_URLU + 'completed-applications/' + cmpId, {
    headers: authHeader()
  });
};

const getTotalMemberLoanNumber = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'total-member-loans/' + cmpId + '/' + memberCode, {
    headers: authHeader()
  });
};

const getTotalMemberLoanAmount = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'total-loan-amount/' + cmpId + '/' + memberCode, {
    headers: authHeader()
  });
};

const getTotalMemberLoanBalance = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'total-loan-balance/' + cmpId + '/' + memberCode, {
    headers: authHeader()
  });
};

const getTotalActiveLoans = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'total-active-loans/' + cmpId + '/' + memberCode, {
    headers: authHeader()
  });
};

const postProvLoans = (data) => {
  return axios.post(API_URLU + 'prov-loans', data, { headers: authHeader() });
};

const putProvLoans = (splId, data) => {
  return axios.put(API_URLU + 'prov-loans/' + splId, data, { headers: authHeader() });
};

const putApprLoans = (salId, data) => {
  return axios.put(API_URLU + 'appr-loans/' + salId, data, { headers: authHeader() });
};

const getPaymentsWithBalance = () => {
  return axios.get(API_URLU + 'payments-wbalance', { headers: authHeader() });
};

const approveMemberLoans = (data) => {
  return axios.get(
    API_URLU + 'approve-member-loans?splId=' + data.splId + '&cmpId=' + data.cmpId + '&rejectedYn=' + data.rejectedYn, { headers: authHeader() });
};

const getBankHeadersBySacco = (cmpId) => {
  return axios.get(API_URLU + 'sac-bank-headers-cmpid/' + cmpId, {
    headers: authHeader()
  });
};

const getActiveBankHeadersBySacco = (cmpId) => {
  return axios.get(API_URLU + 'sac-actbank-headers-cmpid/' + cmpId, {
    headers: authHeader()
  });
};

const postBankHeaders = (data) => {
  return axios.post(API_URLU + 'sac-bank-headers', data, { headers: authHeader() });
};

const putBankHeaders = (sysBankId, data) => {
  return axios.put(API_URLU + 'sac-bank-headers/' + sysBankId, data, { headers: authHeader() });
};

const getBankHeadersById = (sysBankId) => {
  return axios.get(API_URLU + 'sac-bank-headers-id/' + sysBankId, {
    headers: authHeader()
  });
};

const delBankHeaders = (sysBankId) => {
  return axios.delete(API_URLU + 'sac-bank-headers/' + sysBankId, { headers: authHeader() });
};

const getBankBranchesBySacco = (cmpId) => {
  return axios.get(API_URLU + 'sac-bank-branches-cmpid/' + cmpId, {
    headers: authHeader()
  });
};

const postBankBranches = (data) => {
  return axios.post(API_URLU + 'sac-bank-branches', data, { headers: authHeader() });
};

const putBankBranches = (sysBranchId, data) => {
  return axios.put(API_URLU + 'sac-bank-branches/' + sysBranchId, data, { headers: authHeader() });
};

const getBankBranchesById = (sysBranchId) => {
  return axios.get(API_URLU + 'sac-bank-branches-id/' + sysBranchId, {
    headers: authHeader()
  });
};

const getBankBranchesByHeader = (bankHeaderCode, cmpId) => {
  return axios.get(API_URLU + 'sac-bank-branches-byheader-cmpid/' + bankHeaderCode + '/' + cmpId, {
    headers: authHeader()
  });
};

const getActBankBranchesByHeader = (bankHeaderCode, cmpId) => {
  return axios.get(API_URLU + 'sac-actbank-branches-byheader-cmpid/' + bankHeaderCode + '/' + cmpId, {
    headers: authHeader()
  });
};

const getBankBranchesByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'sac-bank-branches-cmpid/' + cmpId, {
    headers: authHeader()
  });
};

const delBankBranches = (sysBranchId) => {
  return axios.delete(API_URLU + 'sac-bank-branches/' + sysBranchId, { headers: authHeader() });
};



const getSacCurrencies = (cmpId) => {
  return axios.get(API_URLU + 'company-currencies/' + cmpId, {
    headers: authHeader()
  });
};

const getCurrencyCodesById = (crrId) => {
  return axios.get(API_URLU + 'company-currencies-id/' + crrId, {
    headers: authHeader()
  });
};

const postCurrencyCodes = (data) => {
  return axios.post(API_URLU + 'all-currencies', data, { headers: authHeader() });
};

const putCurrencyCodes = (crrId, data) => {
  return axios.put(API_URLU + 'all-currencies/' + crrId, data, { headers: authHeader() });
};

const delCurrencyCodes = (crrId) => {
  return axios.delete(API_URLU + 'all-currencies/' + crrId, { headers: authHeader() });
};

const postLoanGuarantors = (data) => {
  return axios.post(API_URLU + 'sac-loan-guarantors', data, { headers: authHeader() });
};

const postLoanGuarantorsSendEmail = (guarantorEmail, memberNames, companyName, data) => {
  return axios.post(API_URLU + 'sac-loan-guarantors-email/' + guarantorEmail + '/' + memberNames + '/' + companyName, data, { headers: authHeader() });
};

const putLoanGuarantors = (sysGuarantorId, data) => {
  return axios.put(API_URLU + 'sac-loan-guarantors/' + sysGuarantorId, data, { headers: authHeader() });
};

const getLoanGuarantorsbyLoan = (splId) => {
  return axios.get(API_URLU + 'sac-loan-guarantors-loan/' + splId, {
    headers: authHeader()
  });
};

const delLoanGuarantors = (sysGuarantorId) => {
  return axios.delete(API_URLU + 'sac-loan-guarantors/' + sysGuarantorId, { headers: authHeader() });
};

const getPendingSaccoSavingsHeaders = (cmpId) => {
  return axios.get(API_URLU + 'pending-savings-headers-cmpid/' + cmpId, {
    headers: authHeader(),
  });
};

const getApprovedSaccoSavingsHeaders = (cmpId) => {
  return axios.get(API_URLU + 'approved-savings-headers-cmpid/' + cmpId, {
    headers: authHeader(),
  });
};

const getSaccoSavingsDetailsByHeaders = (sahSystemId) => {
  return axios.get(API_URLU + 'sac-savings-details-header-id/' + sahSystemId, {
    headers: authHeader(),
  });
};

const postSacSavings = (data) => {
  return axios.post(API_URLU + 'sac-savings-headers', data, { headers: authHeader() });
};

const postSacSavingsDetails = (data) => {
  return axios.post(API_URLU + 'sac-savings-details', data, { headers: authHeader() });
};

const getSavingsHeadersById = (sahSystemId) => {
  return axios.get(API_URLU + 'sac-savings-headers-id/' + sahSystemId, {
    headers: authHeader()
  });
};

const getSavingsDetailsById = (sadSystemId) => {
  return axios.get(API_URLU + 'sac-savings-details-id/' + sadSystemId, {
    headers: authHeader()
  });
};

const putSavingsHeaders = (sahSystemId, data) => {
  return axios.put(API_URLU + 'sac-savings-headers/' + sahSystemId, data, { headers: authHeader() });
};

const putSavingsDetails = (sadSystemId, data) => {
  return axios.put(API_URLU + 'sac-savings-details/' + sadSystemId, data, { headers: authHeader() });
};

const delMemberSavings = (sadSystemId) => {
  return axios.delete(API_URLU + 'sac-savings-details/' + sadSystemId, { headers: authHeader() });
};

const getPendGuaranteeRequests = (cmpId) => {
  return axios.get(API_URLU + 'sac-pending-guarantee-requests/' + cmpId, {
    headers: authHeader(),
  });
};

const getAppRejGuaranteeRequests = (cmpId) => {
  return axios.get(API_URLU + 'sac-apprej-guarantee-requests/' + cmpId, {
    headers: authHeader(),
  });
};

const getMemPendGuaranteeRequests = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'mem-pending-guarantee-requests/' + cmpId + '/' + memberCode, {
    headers: authHeader(),
  });
};

const getMemAppRejGuaranteeRequests = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'mem-apprej-guarantee-requests/' + cmpId + '/' + memberCode, {
    headers: authHeader(),
  });
};

const getGuaranteeRequestsById = (sysGuarantorId) => {
  return axios.get(API_URLU + 'sac-loan-guarantors-id/' + sysGuarantorId, {
    headers: authHeader(),
  });
};

const postSacMembersUpload = (formData) => {
  return axios.post(API_URLU + 'save-sac-members-csv', formData,
    {
      headers: authHeader(),
      "Content-Type": "multipart/form-data",
    });
};

const postSacMemberSavingsUpload = (formData) => {
  return axios.post(API_URLU + 'save-sac-member-savings-csv', formData,
    {
      headers: authHeader(),
      "Content-Type": "multipart/form-data",
    });
};

const updatebankBranchCode = (data) => {
  return axios.get(
    API_URLU +
    'update-branch-bank-code?sysBankId=' +
    data.sysBankId,
    { headers: authHeader() }
  );
};

const getActiveLoanTypes = (cmpId) => {
  return axios.get(API_URLU + 'active-loan-types/' + cmpId, {
    headers: authHeader()
  });
};

const getActiveContributionTypes = (cmpId) => {
  return axios.get(API_URLU + 'active-contrib-types/' + cmpId, {
    headers: authHeader()
  });
};

const getActiveChargeTypes = (cmpId) => {
  return axios.get(API_URLU + 'active-charge-types/' + cmpId, {
    headers: authHeader()
  });
};

const getMemberSaccoSavings = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'member-sacco-savings/' + cmpId + '/' + memberCode, {
    headers: authHeader()
  });
};

const getAcceptedLoanGuarantorsbyLoan = (splId) => {
  return axios.get(API_URLU + 'accepted-loan-guarantors-loan/' + splId, {
    headers: authHeader()
  });
};

const acceptLoanGuarantee = (sysGuarantorId, guarantorEmail, memberNames, companyName, data) => {
  return axios.put(API_URLU + 'approve-sac-loan-guarantors/' + sysGuarantorId + '/' + guarantorEmail + '/' + memberNames + '/' +
    companyName, data, { headers: authHeader() });
};

const declineLoanGuarantee = (sysGuarantorId, guarantorEmail, memberNames, companyName, data) => {
  return axios.put(API_URLU + 'decline-sac-loan-guarantors/' + sysGuarantorId + '/' + guarantorEmail + '/' + memberNames + '/' +
    companyName, data, { headers: authHeader() });
};

const getActiveSacCurrencies = (cmpId) => {
  return axios.get(API_URLU + 'active-company-currencies/' + cmpId, {
    headers: authHeader()
  });
};

const getMemberSaccoLimits = (memberCode, cmpId) => {
  return axios.get(
    API_URLU + 'get-sacco-member-limit?memberCode=' + memberCode + '&cmpId=' + cmpId, { headers: authHeader() });
};

const getSchoolUserCompanies = (id) => {
  return axios.get(API_URLU + 'school-user-companies?userId=' + id, { headers: authHeader() });
};

const companyMenuLink = (data) => {
  return axios.get(
    API_URLU + 'link-cmp-menus?cmpId=' + data.cmpId + '&sstId=' + data.sstId, { headers: authHeader() });
};

const getSchoolStudents = (cmpId) => {
  return axios.get(API_URLU + 'school-students-cmpid/' + cmpId, {
    headers: authHeader()
  });
};

const getStudentCode = (data) => {
  return axios.get(
    API_URLU +
    'get-student-code?cmpId=' +
    data.cmpId,
    { headers: authHeader() }
  );
};

const postSchoolStudents = (data) => {
  return axios.post(API_URLU + 'school-students', data, { headers: authHeader() });
};

const putSchoolStudents = (studentId, data) => {
  return axios.put(API_URLU + 'school-students/' + studentId, data, { headers: authHeader() });
};

const getSchoolStudentsById = (studentId) => {
  return axios.get(API_URLU + 'school-students-id/' + studentId, {
    headers: authHeader()
  });
};

const linkSchoolUser = (data) => {
  return axios.get(
    API_URLU +
    'link-insurance-user?cmpId=' +
    data.cmpId +
    '&sstId=' +
    data.sstId +
    '&usrId=' +
    data.usrId +
    '&accessCodeId=' +
    data.accessCodeId,
    { headers: authHeader() }
  );
};

const postSchoolStudentsUpload = (formData, cmpId, uploadRefNo) => {
  return axios.post(API_URLU + 'upload-school-students-csv?cmpId=' + cmpId + '&uploadRefNo=' + uploadRefNo, formData,
    {
      headers: authHeader(),
      "Content-Type": "multipart/form-data",
    });
};

const reuploadSchoolStudentsUpload = (formData, cmpId, uploadRefNo) => {
  return axios.post(API_URLU + 'reupload-school-students-csv?cmpId=' + cmpId + '&uploadRefNo=' + uploadRefNo, formData,
    {
      headers: authHeader(),
      "Content-Type": "multipart/form-data",
    });
};

const genStudentUploadReferenceNo = () => {
  return axios.get(API_URLU + 'get-student-upload-ref-no', {
    headers: authHeader()
  });
};

const getAcceptedStudentUploads = (cmpId, uploadRefNo) => {
  return axios.get(API_URLU + 'accepted-student-uploads/' + cmpId + '/' + uploadRefNo, {
    headers: authHeader()
  });
};

const getRejectedStudentUploads = (cmpId, uploadRefNo) => {
  return axios.get(API_URLU + 'rejected-student-uploads/' + cmpId + '/' + uploadRefNo, {
    headers: authHeader()
  });
};

const validateStudentUploads = (uploadRefNo, cmpId) => {
  return axios.get(API_URLU + 'validate-students-upload/' + uploadRefNo + '/' + cmpId, {
    headers: authHeader()
  });
};

const postAcceptedSchoolStudentUploads = (data) => {
  return axios.post(API_URLU + 'save-accepted-students?cmpId=' + data.cmpId + '&uploadRefNo=' + data.uploadRefNo
    + '&cmpShortName=' + data.cmpShortName, { headers: authHeader() });
};

const emailStudentsWithoutAccounts = (data) => {
  return axios.post(API_URLU + 'email-students-without-accounts?cmpId=' + data.cmpId, { headers: authHeader() });
};

const linkUnlinkedStudents = (data) => {
  return axios.post(API_URLU + 'link-unlinked-students?cmpId=' + data.cmpId + '&sstId=' + data.sstId
    + '&accessCodeId=' + data.accessCodeId, { headers: authHeader() });
};

const getAllPermittedEmployees = (data) => {
  return axios.get(API_URLU + 'chr-all-permitted-employee?email=' + data.email, { headers: authHeader() });
};

const getContractTypesByCmp = () => {
  return axios.get(API_URLU + 'chr-contract-general-codes', { headers: authHeader() });
}

const getEmployeeByCategoryCode = (code) => {
  return axios.get(API_URLU + 'chr_by_category/' + code, { headers: authHeader() });
};

const getChrCompanyBranches = () => {
  return axios.get(API_URLU + 'branch', { headers: authHeader() });
}

const getChrFundingSourceGeneralCodesByCmpId = () => {
  return axios.get(API_URLU + 'chr-funding-general-codes', { headers: authHeader() });
}

const getUserPermittedChrEmpCategories = (email) => {
  return axios.get(API_URLU + 'chr-emp-categories?email=' + email, { headers: authHeader() });
}

const getChrRelationTypesByCmpId = () => {
  return axios.get(API_URLU + 'chr-relation-types', { headers: authHeader() });
}

const getChrRelationTypesByCompanyId = (cmpId) => {
  return axios.get(API_URLU + 'chr-relation-types-cmpid?cmpId=' + cmpId, { headers: authHeader() });
}

const getChrCompany = (cmpId) => {
  return axios.get(API_URLU + 'chr-company?cmpId=' + cmpId, { headers: authHeader() });
}

const getActiveChrEmployeesByCmp = () => {
  return axios.get(API_URLU + 'chr-active-employees', { headers: authHeader() });
}

const getChrJobTitlesByCmp = () => {
  return axios.get(API_URLU + 'chr-job-titles', { headers: authHeader() });
}

const getChrCompanyDepartments = () => {
  return axios.get(API_URLU + 'cms-departments', { headers: authHeader() });
}

const getChrJobGroupsByCmp = () => {
  return axios.get(API_URLU + 'chr-job-groups', { headers: authHeader() });
}

const getChrLeaveTypesByCmp = () => {
  return axios.get(API_URLU + 'chr-leave-types', { headers: authHeader() });
}

const getChrAnnualLeaveTypesByCmp = () => {
  return axios.get(API_URLU + 'chr-annual-leave-types', { headers: authHeader() });
}

const getChrCoursesByCmp = () => {
  return axios.get(API_URLU + 'chr-courses', { headers: authHeader() });
}

const getFixedAssetCategoriesByCmp = () => {
  return axios.get(API_URLU + 'cfs-asset-cat-details', { headers: authHeader() });
}

const getItemsByCategory = (categoryCode) => {
  return axios.get(API_URLU + 'cfs-asset-definitions?categoryCode=' + categoryCode, { headers: authHeader() });
}

const postEmployee = (data) => {
  return axios.post(API_URLU + 'chr_employee', data, { headers: authHeader() });
};

const postEmployeePeriods = (data) => {
  return axios.post(API_URLU + 'chr-employee-periods', data, { headers: authHeader() });
};

const putEmployee = (data) => {
  return axios.put(API_URLU + 'chr_employee/' + data.empId, data, { headers: authHeader() });
};

const postEmployeeRelation = (data) => {
  return axios.post(API_URLU + 'chr-emp-relations', data, { headers: authHeader() });
};

const putEmployeeRelation = (data) => {
  return axios.put(API_URLU + 'chr-emp-relations/' + data.erlId, data, { headers: authHeader() });
};

const postEmployeeLeave = (data) => {
  return axios.post(API_URLU + 'chr-emp-leaves', data, { headers: authHeader() });
};

const putEmployeeLeave = (data) => {
  return axios.put(API_URLU + 'chr-emp-leaves/' + data.elvId, data, { headers: authHeader() });
};

const postEmployeeQualification = (data) => {
  return axios.post(API_URLU + 'chr-emp-qualifications', data, { headers: authHeader() });
};

const putEmployeeQualification = (data) => {
  return axios.put(API_URLU + 'chr-emp-qualifications/' + data.mqlId, data, { headers: authHeader() });
};

const postEmployeeReferee = (data) => {
  return axios.post(API_URLU + 'chr-referees', data, { headers: authHeader() });
};

const putEmployeeReferee = (data) => {
  return axios.put(API_URLU + 'chr-referees/' + data.rfrId, data, { headers: authHeader() });
};

const postEmployeeItem = (data) => {
  return axios.post(API_URLU + 'cst-emp-items', data, { headers: authHeader() });
};

const putEmployeeItem = (data) => {
  return axios.put(API_URLU + 'cst-emp-items/' + data.eitId, data, { headers: authHeader() });
};

const getEmployeeRelationsByEmployeeCode = (data) => {
  return axios.get(API_URLU + 'chr-emp-relations?employeeCode=' + data.employeeCode, { headers: authHeader() });
}

const getEmployeeItemsByEmployeeCode = (data) => {
  return axios.get(API_URLU + 'cst-emp-items?&employeeCode=' + data.employeeCode, { headers: authHeader() });
}

const getEmployeeLeavesByEmployeeCode = (data) => {
  return axios.get(API_URLU + 'chr-emp-leaves?employeeCode=' + data.employeeCode, { headers: authHeader() });
}

const getEmployeeRefereesByEmployeeCode = (data) => {
  return axios.get(API_URLU + 'chr-referees?employeeCode=' + data.employeeCode, { headers: authHeader() });
}

const getEmployeePeriodsByEmployeeCode = (data) => {
  return axios.get(API_URLU + 'chr-employee-periods-byemployee?empCode=' + data.employeeCode, { headers: authHeader() });
};

const generateEmployeeCode = (data) => {
  return axios.get(
    API_URLU + "generate-employee-code?cmpId=" + data.cmpId,
    { headers: authHeader() }
  );
};

const getCustTypeByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'cust-type-cmpid/' + cmpId, { headers: authHeader() });
};

const getClientTypeByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'client-type-cmpid/' + cmpId, { headers: authHeader() });
};

const getIdentificationTypeByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'identification-type-cmpid/' + cmpId, { headers: authHeader() });
};

const getOccupationCodesByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'occupation-codes-cmpid/' + cmpId, { headers: authHeader() });
};

const getOnluserInsurerCustomersByCmpId = (cmpId, usrId) => {
  return axios.get(API_URLU + 'onlusers-insurance-customer-cmpid/' + cmpId + '/' + usrId, { headers: authHeader() });
};

const getCustClassificationByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'cust-classification-cmpid/' + cmpId, { headers: authHeader() });
};

const getDiscountCategoryByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'discount-category-cmpid/' + cmpId, { headers: authHeader() });
};

const getUsersPermittedForCustomers = (cmpId, custCode) => {
  return axios.get(API_URLU + 'users-permitted-cust/' + cmpId + '/' + custCode, { headers: authHeader() });
};

const getCompanyClassifiedCustomerCode = (data) => {
  return axios.get(
    API_URLU +
    'get-company-classified-custcode?cmpId=' +
    data.cmpId + '&serialCode=' + data.serialCode,
    { headers: authHeader() }
  );
};

const postOnlineCredential = (data) => {
  return axios.post(API_URLU + 'customer-credentials', data, { headers: authHeader() });
};

const getPermittedCustomerById = (copId) => {
  return axios.get(API_URLU + 'permitted-customers-id/' + copId, { headers: authHeader() });
};

const putOnlineCredential = (copId, data) => {
  return axios.put(API_URLU + 'customer-credentials/' + copId, data, { headers: authHeader() });
};

const getCustomerById = (data) => {
  return axios.get(
    API_URLU +
    "customerCode?cmpId=" +
    data.cmpId +
    "&custCode=" +
    data.custCode,
    { headers: authHeader() }
  );
};

const getMainAccountWithGroupsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "cfsmain-acc-descr-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getAllCfsMainAccounts = (cmpId) => {
  return axios.get(API_URLU + "cfs-all-main-accounts/" + cmpId, {
    headers: authHeader(),
  });
};

const getFrozenMainAccountWithGroupsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "cfsmain-acc-frozen-descr-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getCfsAccountYearsByCmpid = (cmpId) => {
  return axios.get(API_URLU + "cfs-acc-years/" + cmpId, {
    headers: authHeader(),
  });
};

const getAccountGroupsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "account-groups-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const getCfsMainSubAccountsbyAccountCode = (accountCode, cmpId) => {
  return axios.get(
    API_URLU + "cfs-main-subaccounts-account/" + accountCode + "/ " + cmpId,
    { headers: authHeader() }
  );
};

const getSubAccountsToLinkByAccountCode = (cmpId, accountCode) => {
  return axios.get(
    API_URLU + "subaccounts-link-account/" + cmpId + "/" + accountCode,
    {
      headers: authHeader(),
    }
  );
};

const getAccBudgetsByCmpIdandYearandAccountCode = (data) => {
  return axios.get(
    API_URLU +
    "cfs-acc-budgets-acccode?cmpId=" +
    data.cmpId +
    "&calendarYear=" +
    data.calendarYear +
    "&accountCode=" +
    data.accountCode,
    { headers: authHeader() }
  );
};

const getAccBranchBudgetsByAccountYearandMonth = (data) => {
  return axios.get(
    API_URLU +
    "cfs-branch-budgets-acccode?cmpId=" +
    data.cmpId +
    "&calendarYear=" +
    data.calendarYear +
    "&calendarMonth=" +
    data.calendarMonth +
    "&accountCode=" +
    data.accountCode,
    { headers: authHeader() }
  );
};

const getAccDeptBudgetsByYearAndMonthAccountAndBranch = (data) => {
  return axios.get(
    API_URLU +
    "cfs-dept-budgets-acccode?cmpId=" +
    data.cmpId +
    "&calendarYear=" +
    data.calendarYear +
    "&calendarMonth=" +
    data.calendarMonth +
    "&accountCode=" +
    data.accountCode +
    "&branchCode=" +
    data.branchCode,
    { headers: authHeader() }
  );
};

const postCfsMainAccounts = (data) => {
  return axios.post(API_URLU + "cfs-main-accounts", data, {
    headers: authHeader(),
  });
};

const postCfsMainSubAccounts = (data) => {
  return axios.post(API_URLU + "cfs-main-subaccounts", data, {
    headers: authHeader(),
  });
};

const getCfsMainAccountsById = (macId) => {
  return axios.get(API_URLU + "cfs-main-accounts-id/" + macId, {
    headers: authHeader(),
  });
};

const putCfsMainAccounts = (id, data) => {
  return axios.put(API_URLU + "cfs-main-accounts/" + id, data, {
    headers: authHeader(),
  });
};

const delinkSubAccount = (msaId) => {
  return axios.delete(API_URLU + "cfs-main-subaccounts/" + msaId, {
    headers: authHeader(),
  });
};

const deleteMainAccount = (macId) => {
  return axios.delete(API_URLU + "cfs-main-accounts/" + macId, {
    headers: authHeader(),
  });
};

const getCompanyBranches = (id) => {
  return axios.get(API_URLU + "company-branches/" + id, {
    headers: authHeader(),
  });
};

const getBranch = (id) => {
  return axios.get(API_URLU + "branch/" + id, { headers: authHeader() });
};

const getDepartmentsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "cms-department-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const postDepartments = (data) => {
  return axios.post(API_URLU + "cms-departments", data, {
    headers: authHeader(),
  });
};

const updateDepartments = (data) => {
  return axios.put(API_URLU + "cms-departments/" + data.dprId, data, {
    headers: authHeader(),
  });
};

const getDepartmentsById = (dprId) => {
  return axios.get(API_URLU + "cms-departments-id/" + dprId, {
    headers: authHeader(),
  });
};

const postCostCenters = (data) => {
  return axios.post(API_URLU + "cost-centers", data, {
    headers: authHeader(),
  });
};

const updateCostCenters = (data) => {
  return axios.put(API_URLU + "cost-centers/" + data.cstId, data, {
    headers: authHeader(),
  });
};

const getCostCentersById = (cstId) => {
  return axios.get(API_URLU + "cost-centers-id/" + cstId, {
    headers: authHeader(),
  });
};

const getCostCentersByCmpId = (cmpId) => {
  return axios.get(API_URLU + "cost-centers-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const putCompany = (cmpId, data) => {
  return axios.put(API_URLU + "company/" + cmpId, data, {
    headers: authHeader(),
  });
};

const putBranch = (id, data) => {
  return axios.put(API_URLU + "branch/" + id, data, { headers: authHeader() });
};

const postBranch = (data) => {
  return axios.post(API_URLU + "branch", data, { headers: authHeader() });
};

const getCfsCompanyBanks = (cmpId) => {
  return axios.get(API_URLU + "cfs-company-banks-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getCfsCompanyBankChqDetails = (cbnId) => {
  return axios.get(API_URLU + "cfs-chq-details-cbnId/" + cbnId, {
    headers: authHeader(),
  });
};

const getMainAccountsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "cfsmain-acccmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getActiveCurrency = (cmpId) => {
  return axios.get(API_URLU + "active-company-currencies/" + cmpId, {
    headers: authHeader(),
  });
};

const postCfsCompanyBanks = (data) => {
  return axios.post(API_URLU + "cfs-company-banks", data, {
    headers: authHeader(),
  });
};

const updateCfsCompanyBanks = (data) => {
  return axios.put(API_URLU + "cfs-company-banks/" + data.cbnId, data, {
    headers: authHeader(),
  });
};

const postCfsCompanyBankCheque = (data) => {
  return axios.post(API_URLU + "cfs-chq-details", data, {
    headers: authHeader(),
  });
};

const updateCfsCompanyBankCheque = (data) => {
  return axios.put(API_URLU + "cfs-chq-details/" + data.bcdId, data, {
    headers: authHeader(),
  });
};

const getSubAccountsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "cfs-sub-accounts-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getCustomersToCreateSubAccount = (cmpId) => {
  return axios.get(API_URLU + "customers-create-subaccount/" + cmpId, {
    headers: authHeader(),
  });
};

const postMainSubAccounts = (data) => {
  return axios.post(API_URLU + "cfs-main-subaccounts", data, {
    headers: authHeader(),
  });
};

const postSubAccounts = (data) => {
  return axios.post(API_URLU + "cfs-sub-accounts", data, {
    headers: authHeader(),
  });
};

const putSubAccounts = (sacId, data) => {
  return axios.put(API_URLU + "cfs-sub-accounts/" + sacId, data, {
    headers: authHeader(),
  });
};

const getSubAccountsById = (sacId) => {
  return axios.get(API_URLU + "cfs-sub-accounts-id/" + sacId, {
    headers: authHeader(),
  });
};

const getAccountsToLinkBySubaccountCode = (cmpId, subaccountCode) => {
  return axios.get(
    API_URLU + "accounts-link-subaccountcode/" + cmpId + "/" + subaccountCode,
    {
      headers: authHeader(),
    }
  );
};

const getAllTranCodes = (cmpId) => {
  return axios.get(API_URLU + "transaction-codes?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const postTranCode = (data) => {
  return axios.post(API_URLU + "transaction-codes", data, {
    headers: authHeader(),
  });
};

const updateTranCode = (data) => {
  return axios.put(API_URLU + "transaction-codes/" + data.trcId, data, {
    headers: authHeader(),
  });
};

const getAllTranPrivs = (data) => {
  return axios.get(
    API_URLU +
    "transaction-privs?cmpId=" +
    data.cmpId +
    "&tranCode=" +
    data.tranCode,
    {
      headers: authHeader(),
    }
  );
};

const postTranPrivs = (data) => {
  return axios.post(API_URLU + "transaction-privs", data, {
    headers: authHeader(),
  });
};

const updateTranPrivs = (data) => {
  return axios.put(API_URLU + "transaction-privs/" + data.tprId, data, {
    headers: authHeader(),
  });
};

const getCompanySystemUsers = (cmpId, sstId) => {
  return axios.get(API_URLU + "cmp-sst-user/" + cmpId + "/" + sstId, {
    headers: authHeader(),
  });
};

const getTranSerialsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "tran-serials-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const getAllTranSerials = (data) => {
  return axios.get(
    API_URLU +
    "tran-serials-trancode?cmpId=" +
    data.cmpId +
    "&tranCode=" +
    data.tranCode,
    {
      headers: authHeader(),
    }
  );
};

const updateTranSerials = (data) => {
  return axios.put(API_URLU + "tran-serials/" + data.tsrId, data, {
    headers: authHeader(),
  });
};

const postTranSerials = (data) => {
  return axios.post(API_URLU + "tran-serials", data, {
    headers: authHeader(),
  });
};

const getReceiptHeadersByCmpid = (cmpId) => {
  return axios.get(API_URLU + "receipt-headers-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const postReceiptHeader = (data) => {
  return axios.post(API_URLU + "receipt-headers", data, {
    headers: authHeader(),
  });
};

const putReceiptHeader = (id, data) => {
  return axios.put(API_URLU + "receipt-headers/" + id, data, {
    headers: authHeader(),
  });
};

const getReceiptHeader = (id) => {
  return axios.get(API_URLU + "receipt-headers-id/" + id, {
    headers: authHeader(),
  });
};

const postReceiptDetails = (data) => {
  return axios.post(API_URLU + "receipt-details", data, {
    headers: authHeader(),
  });
};

const putReceiptDetails = (id, data) => {
  return axios.put(API_URLU + "receipt-details/" + id, data, {
    headers: authHeader(),
  });
};

const getReceiptDetails = (id) => {
  return axios.get(API_URLU + "receipt-details-id/" + id, {
    headers: authHeader(),
  });
};

const deleteReceiptDetail = (id) => {
  return axios.delete(API_URLU + "receipt-details/" + id, {
    headers: authHeader(),
  });
};

const getReceiptDetailsByHeaderId = (rdtRhdId) => {
  return axios.get(API_URLU + "receipt-details-headerid/" + rdtRhdId, {
    headers: authHeader(),
  });
};

const findPaymentModesByCmpId = (cmpid) => {
  return axios.get(API_URLU + "payment-modes-cmpid/" + cmpid, {
    headers: authHeader(),
  });
};

const findReceiptTransactionCodes = (cmpid) => {
  return axios.get(API_URLU + "cfsreceipt-codes/" + cmpid, {
    headers: authHeader(),
  });
};

const getCashBankMainAccounts = (cmpid) => {
  return axios.get(API_URLU + "cash-bank-main-accounts/" + cmpid, {
    headers: authHeader(),
  });
};

const getAssetMainAccountsSubAccounts = (cmpid) => {
  return axios.get(API_URLU + "asset-main-sub-accounts/" + cmpid, {
    headers: authHeader(),
  });
};

const getAllglTransactions = (cmpId) => {
  return axios.get(API_URLU + "allgl-transactions/" + cmpId, {
    headers: authHeader(),
  });
};

const getAllCustomersByCmpId = (cmpId) => {
  return axios.get(API_URLU + "insurance-customer-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getBranchesByCmpId = (cmpId) => {
  return axios.get(API_URLU + "branches-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getCustomerSalesForReceiptsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "receiptcfs-customer-sales-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const getWalkinSalesForReceiptsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "receiptcfs-walkin-sales-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const getControlAccountsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "account-control-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const getTransactionPrivsByCmpIdAndTranCodeAndUserName = (dtls) => {
  return axios.get(
    API_URLU +
    "tran-privsby-user?cmpId=" +
    dtls.cmpId +
    "&tranCode=" +
    dtls.tranCode +
    "&userName=" +
    dtls.userName,
    { headers: authHeader() }
  );
};

const getReceiptGlTransactionDetailsByHeaderId = (rhdId) => {
  return axios.get(API_URLU + "gl-receipt-tran-dets/" + rhdId, {
    headers: authHeader(),
  });
};

const approveReceiptHeader = (cmpId, rhdId, user) => {
  return axios.get(
    API_URLU + "approve-receipt-header/" + cmpId + "/" + rhdId + "/" + user,
    { headers: authHeader() }
  );
};

const getJournalVoucher = (data) => {
  return axios.get(
    API_URLU +
    "journal-voucher?reportFormat=" +
    data.reportFormat +
    "&repName=" +
    data.repName +
    "&jhdId=" +
    data.jhdId +
    "&narration=" +
    data.narration +
    "&status=" +
    data.status +
    "&description=" +
    data.description +
    "&totalCredits=" +
    data.totalCredits +
    "&totalDebits=" +
    data.totalDebits +
    "&docDate=" +
    data.docDate +
    "&createdDate=" +
    data.createdDate +
    "&approvedDate=" +
    data.approvedDate +
    "&createdBy=" +
    data.createdBy +
    "&approvedBy=" +
    data.approvedBy +
    "&docNumber=" +
    data.docNumber +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getReceipt = (data) => {
  return axios.get(
    API_URLU +
    "accounts-report?reportFormat=" +
    data.reportFormat +
    "&repName=" +
    data.repName +
    "&rhdId=" +
    data.rhdId +
    "&cmpId=" +
    data.cmpId +
    "&user=" +
    data.user,
    {
      headers: authHeader(),
    }
  );
};

const fetchAllUnbankedReceipts = (data) => {
  return axios.get(
    API_URLU +
    "all-unbanked-receipts", {
    params: data,
    headers: authHeader(),
  });
};

const fetchFilteredUnbankedReceipts = (data) => {
  return axios.get(
    API_URLU +
    "filtered-unbanked-receipts", {
    params: data,
    headers: authHeader(),
  });
};

const findOtherTransactionCodes = (cmpid) => {
  return axios.get(API_URLU + "cfsother-codes/" + cmpid, {
    headers: authHeader(),
  });
};

const fetchAllReceiptBankingHeaders = (cmpId) => {
  return axios.get(API_URLU + "all-banking-headers/" + cmpId, {
    headers: authHeader(),
  });
};

const getBankedReceiptDetailsByHeaderId = (rbhId, cmpId) => {
  return axios.get(API_URLU + "banking-receipt-details-header/" + rbhId + "/" + cmpId, {
    headers: authHeader(),
  });
};

const getReceiptBankingGlTransactionDetailsByHeaderId = (rbhId) => {
  return axios.get(API_URLU + "gl-receipt-bank-dets/" + rbhId, {
    headers: authHeader(),
  });
};

const putReceiptBankHeader = (id, data) => {
  return axios.put(API_URLU + "bank-receipt-header/" + id, data, {
    headers: authHeader(),
  });
};

const approveReceiptBanking = (data) => {
  return axios.get(
    API_URLU +
    "approve-receipt-banking?rbhId=" +
    data.rbhId +
    "&cmpId=" +
    data.cmpId +
    "&user=" +
    data.user,
    { headers: authHeader() }
  );
};

const getInvoicesWithBalanceForPayment = (cmpId) => {
  return axios.get(API_URLU + "invoice-with-balance?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getPoReportDetailsByPhd = (data) => {
  return axios.get(
    API_URLU +
    "po-details-byphd?cmpId=" +
    data.cmpId +
    "&userId=" +
    data.userId +
    "&approvalStatus=" +
    data.approvalStatus +
    "&phdId=" +
    data.phdId,
    {
      headers: authHeader(),
    }
  );
};

const getPoHBalnce = (data) => {
  return axios.get(
    API_URLU +
    "po-balance?cmpId=" +
    data.cmpId +
    "&userId=" +
    data.userId +
    "&supplierCode=" +
    data.supplierCode,
    {
      headers: authHeader(),
    }
  );
};

const getPaymentDetailsByHeaderId = (data) => {
  return axios.get(
    API_URLU +
    "payment-details_vw?phdId=" +
    data.phdId +
    "&userId=" +
    data.userId +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getPaymentParticularByHeaderId = (data) => {
  return axios.get(
    API_URLU +
    "payment-particular_vw?phdId=" +
    data.phdId +
    "&userId=" +
    data.userId +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const postPaymentInvoices = (data) => {
  return axios.post(API_URLU + "payment-invoices", data, {
    headers: authHeader(),
  });
};

const getInvoicesPaidByPayment = (phdId) => {
  return axios.get(API_URLU + "inv-paidby-payment?phdId=" + phdId, {
    headers: authHeader(),
  });
};

const getPaymentGlTransactionDetailsByHeaderId = (phdId) => {
  return axios.get(API_URLU + "gl-payment-tran-dets/" + phdId, {
    headers: authHeader(),
  });
};

const getPaymentsonSelectedInvoice = (cmpId, invoicePhdId) => {
  return axios.get(API_URLU + "payments-selected-invoice/" + cmpId + "/" + invoicePhdId, {
    headers: authHeader(),
  });
};

const getDefaultAccounts = (cmpId) => {
  return axios.get(API_URLU + "company-defaults/" + cmpId, {
    headers: authHeader(),
  });
};

const getUserRights = (data) => {
  return axios.get(
    API_URLU +
    "userRights?sstId=" +
    data.sstId +
    "&username=" +
    data.username +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getPaymentVoucher = (data) => {
  return axios.get(
    API_URLU +
    "accounts-report?reportFormat=" +
    data.reportFormat +
    "&repName=" +
    data.repName +
    "&phdId=" +
    data.phdId +
    "&cmpId=" +
    data.cmpId +
    "&user=" +
    data.user,
    {
      headers: authHeader(),
    }
  );
};

const getInvoiceReport = (data) => {
  return axios.get(
    API_URLU +
    "accounts-report", {
    params: data,
    headers: authHeader(),
  });
};

const getAllCompanySuppliers = (cmpId) => {
  return axios.get(API_URLU + "company-suppliers?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getJournalsByCmpId = (data) => {
  return axios.get(
    API_URLU +
    "journals-cmpid/" +
    data.id +
    "/" +
    data.offset +
    "/" +
    data.pageSize,
    { headers: authHeader() }
  );
};

const getJournalsByCmpIdAndId = (data) => {
  return axios.get(
    API_URLU +
    "journals-cmpid-id/" +
    data.id +
    "/" +
    data.tranCode +
    "/" +
    data.offset +
    "/" +
    data.pageSize,
    {
      headers: authHeader(),
    }
  );
};

const getJournalDetailsByHeaders = (jdtJhdId) => {
  return axios.get(API_URLU + "journal-details-header-id/" + jdtJhdId, {
    headers: authHeader(),
  });
};

const getJournalRepDetailsByHeaders = (jdtJhdId) => {
  return axios.get(API_URLU + "journal-repdetails-header-id/" + jdtJhdId, {
    headers: authHeader(),
  });
};

const postJournalHeaders = (data) => {
  return axios.post(API_URLU + "journal-headers", data, {
    headers: authHeader(),
  });
};

const postJournalDetails = (data) => {
  return axios.post(API_URLU + "journal-details", data, {
    headers: authHeader(),
  });
};

const putJournalHeaders = (jhdId, data) => {
  return axios.put(API_URLU + "journal-headers/" + jhdId, data, {
    headers: authHeader(),
  });
};

const putJournalDetails = (jdtId, data) => {
  return axios.put(API_URLU + "journal-details/" + jdtId, data, {
    headers: authHeader(),
  });
};

const getJournalDetailsById = (jdtId) => {
  return axios.get(API_URLU + "journal-details-id/" + jdtId, {
    headers: authHeader(),
  });
};

const deleteJournalDetail = (jdtId) => {
  return axios.delete(API_URLU + "journal-details/" + jdtId, {
    headers: authHeader(),
  });
};

const approveJournalHeader = (data) => {
  return axios.get(
    API_URLU +
    "approve-journal-header?jhdId=" +
    data.jhdId +
    "&user=" +
    data.user,
    { headers: authHeader() }
  );
};

const reverseGlTransaction = (data) => {
  return axios.get(
    API_URLU +
    "reversegl-transaction?cmpId=" +
    data.cmpId +
    "&gthId=" +
    data.gthId +
    "&jhdId=" +
    data.jhdId +
    "&remarks=" +
    data.remarks +
    "&user=" +
    data.user +
    "&tranCode=" +
    data.tranCode +
    "&docNumber=" +
    data.docNumber +
    "&docDate=" +
    data.docDate,
    { headers: authHeader() }
  );
};

const getJournalTransactionCodes = (cmpId) => {
  return axios.get(API_URLU + "cfsjournals-codes/" + cmpId, {
    headers: authHeader(),
  });
};

const getJournalGlTransactionDetailsByHeaderId = (jhdId) => {
  return axios.get(API_URLU + "gl-journal-tran-dets/" + jhdId, {
    headers: authHeader(),
  });
};

const getJournalReport = (data) => {
  return axios.get(
    API_URLU +
    "accounts-report?reportFormat=" +
    data.reportFormat +
    "&repName=" +
    data.repName +
    "&jhdId=" +
    data.jhdId +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getCfsReportcategories = (cmpId) => {
  return axios.get(API_URLU + "cfs-report-categories-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const runAccountsReport = (dts) => {
  return axios.get(
    API_URLU +
    "accounts-report?reportFormat=" +
    dts.reportFormat +
    "&repName=" +
    dts.repName +
    "&cmpId=" +
    dts.cmpId +
    "&startDate=" +
    dts.startDate +
    "&endDate=" +
    dts.endDate +
    "&branchCode=" +
    dts.branchCode +
    "&firstAccount=" +
    dts.firstAccount +
    "&lastAccount=" +
    dts.lastAccount +
    "&accountCode=" +
    dts.accountCode +
    "&subaccountCode=" +
    dts.subaccountCode,
    { headers: authHeader() }
  );
};

const getAccountReports = () => {
  return axios.get(API_URLU + "get-cfs-reports", {
    headers: authHeader(),
  });
};

const getGlActivityReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-gl-activity-report?startDate=" +
    dts.startDate +
    "&endDate=" +
    dts.endDate +
    "&branchCode=" +
    dts.branchCode +
    "&cmpId=" +
    dts.cmpId +
    "&accountCode=" +
    dts.accountCode +
    "&subaccountCode=" +
    dts.subaccountCode,
    { headers: authHeader() }
  );
};

const getTrialBalanceReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-trial-balance-report?cmpId=" +
    dts.cmpId +
    "&firstAccount=" +
    dts.firstAccount +
    "&lastAccount=" +
    dts.lastAccount +
    "&startDate=" +
    dts.startDate +
    "&endDate=" +
    dts.endDate,
    { headers: authHeader() }
  );
};

const getJournalListingReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-journal-listing-report?cmpId=" +
    dts.cmpId +
    "&startDate=" +
    dts.startDate +
    "&endDate=" +
    dts.endDate +
    "&branchCode=" +
    dts.branchCode,
    { headers: authHeader() }
  );
};

const getPaymentListingReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-payment-listing-report?cmpId=" +
    dts.cmpId +
    "&startDate=" +
    dts.startDate +
    "&endDate=" +
    dts.endDate +
    "&branchCode=" +
    dts.branchCode,
    { headers: authHeader() }
  );
};

const getReceiptListingReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-receipt-listing-report?cmpId=" +
    dts.cmpId +
    "&startDate=" +
    dts.startDate +
    "&endDate=" +
    dts.endDate +
    "&branchCode=" +
    dts.branchCode,
    { headers: authHeader() }
  );
};

const getMainAccountsReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-main-accounts-report?cmpId=" +
    dts.cmpId,
    { headers: authHeader() }
  );
};

const getMainSubAccountsReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-main-subaccounts-report?cmpId=" +
    dts.cmpId,
    { headers: authHeader() }
  );
};

const getStatementOfAccountsReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-account-statement-report?cmpId=" +
    dts.cmpId +
    "&subaccountCode=" +
    dts.subaccountCode +
    "&startDate=" +
    dts.startDate,
    { headers: authHeader() }
  );
};

const getDebtorsAgedListingReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-debtors-ageing-report?cmpId=" +
    dts.cmpId +
    "&accountCode=" +
    dts.accountCode +
    "&endDate=" +
    dts.endDate,
    { headers: authHeader() }
  );
};

const getCfsReportsByCatId = (catId) => {
  return axios.get(API_URLU + "cfs-reports-catid/" + catId, {
    headers: authHeader(),
  });
};

const runSchoolReport = (dts) => {
  return axios.get(
    API_URLU +
    "school-report?reportFormat=" +
    dts.reportFormat +
    "&repName=" +
    dts.repName +
    "&cmpId=" +
    dts.cmpId +
    "&status=" +
    dts.status  +
    "&sacId=" +
    dts.sacId +
    "&xmhId=" +
    dts.xmhId +
    "&studentCode=" +
    dts.studentCode,
    { headers: authHeader() }
  );
};

const getSchoolReportCategories = () => {
  return axios.get(API_URLU + "scl-report-categories", {
    headers: authHeader(),
  });
};

const getSchoolReportsByCatCode = (catCode) => {
  return axios.get(API_URLU + "school-reports-category?catCode=" + catCode, {
    headers: authHeader(),
  });
};

const getStudentsListingReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-school-students-report?cmpId=" +
    dts.cmpId +
    "&status=" +
    dts.status,
    { headers: authHeader() }
  );
};

const getSchoolYearsByCmpid = (cmpId) => {
  return axios.get(API_URLU + "scl-years-cmpid?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const postSchoolYears = (data) => {
  return axios.post(API_URLU + "scl-years", data, {
    headers: authHeader(),
  });
};

const putSchoolYears = (data) => {
  return axios.put(API_URLU + "scl-years/" + data.sayId, data, {
    headers: authHeader(),
  });
};

const getSchoolTermsByCmpid = (cmpId) => {
  return axios.get(API_URLU + "term-codes-cmpid?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const postSchoolTerms = (data) => {
  return axios.post(API_URLU + "term-codes", data, {
    headers: authHeader(),
  });
};

const putSchoolTerms = (data) => {
  return axios.put(API_URLU + "term-codes/" + data.trcId, data, {
    headers: authHeader(),
  });
};

const getSchoolStreamsByCmpid = (cmpId) => {
  return axios.get(API_URLU + "scl-streams-cmpid?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const postSchoolStreams = (data) => {
  return axios.post(API_URLU + "scl-streams", data, {
    headers: authHeader(),
  });
};

const putSchoolStreams = (data) => {
  return axios.put(API_URLU + "scl-streams/" + data.strId, data, {
    headers: authHeader(),
  });
};

const getSchoolGradesByCmpid = (cmpId) => {
  return axios.get(API_URLU + "scl-grades-cmpid?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const postSchoolGrades = (data) => {
  return axios.post(API_URLU + "scl-grades", data, {
    headers: authHeader(),
  });
};

const putSchoolGrades = (data) => {
  return axios.put(API_URLU + "scl-grades/" + data.grdId, data, {
    headers: authHeader(),
  });
};

const getActivityTermsByCalendarYear = (cmpId, calendarYear) => {
  return axios.get(API_URLU + "activity-terms-calendar-year?cmpId=" + cmpId + '&calendarYear=' + calendarYear, {
    headers: authHeader(),
  });
};

const postActivityTerms = (data) => {
  return axios.post(API_URLU + "activity-terms", data, {
    headers: authHeader(),
  });
};

const putActivityTerms = (data) => {
  return axios.put(API_URLU + "activity-terms/" + data.satId, data, {
    headers: authHeader(),
  });
};

const postActivityClasses = (data) => {
  return axios.post(API_URLU + "activity-classes", data, {
    headers: authHeader(),
  });
};

const putActivityClasses = (data) => {
  return axios.put(API_URLU + "activity-classes/" + data.sacId, data, {
    headers: authHeader(),
  });
};

const getActivityClassesByStreamAndGrade = (data) => {
  return axios.get(API_URLU + "activity-classes-stream-grade?cmpId=" + data.cmpId + '&gradeCode=' + data.gradeCode + '&streamCode=' + data.streamCode, {
    headers: authHeader(),
  });
};

const getSchoolEmployees = (cmpId) => {
  return axios.get(API_URLU + "get-cmp-employees?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getSchoolJobCategories = (cmpId) => {
  return axios.get(API_URLU + "hr-job-titles-cmpid?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getEmployeeRelationsByEmployeeCodeCmpId = (data) => {
  return axios.get(API_URLU + 'chr-emp-relations-cmpid?employeeCode=' + data.employeeCode + '&cmpId=' + data.cmpId, { headers: authHeader() });
}

const getActiveSchoolTeachersByCmpid = (cmpId) => {
  return axios.get(API_URLU + "chr-active-school-teachers?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getActivityStudentsBySacId = (sacId) => {
  return axios.get(API_URLU + "activity-class-students-class?sacId=" + sacId, {
    headers: authHeader(),
  });
};

const postActivityStudents = (data) => {
  return axios.post(API_URLU + "activity-class-students", data, {
    headers: authHeader(),
  });
};

const putActivityStudents = (data) => {
  return axios.put(API_URLU + "activity-class-students/" + data.sasId, data, {
    headers: authHeader(),
  });
};

const getSchoolFeesByCmpid = (cmpId) => {
  return axios.get(API_URLU + "fee-codes-cmpid?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const postSchoolFees = (data) => {
  return axios.post(API_URLU + "fee-codes", data, {
    headers: authHeader(),
  });
};

const putSchoolFees = (data) => {
  return axios.put(API_URLU + "fee-codes/" + data.fecId, data, {
    headers: authHeader(),
  });
};

const getEndYearJournalsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "endyear-journal-headers/" + cmpId, {
    headers: authHeader(),
  });
};

const generateEndYearJournalBrief = (data) => {
  return axios.get(
    API_URLU +
    "generate-yearend-journals?endDate=" +
    data.endDate +
    "&user=" +
    data.user +
    "&cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode,
    { headers: authHeader() }
  );
};

const getJournalHeadersById = (jhdId) => {
  return axios.get(API_URLU + "journal-headers-id/" + jhdId, {
    headers: authHeader(),
  });
};

const clearOrPurgeEndYearJournalBrief = (data) => {
  return axios.get(
    API_URLU +
    "clear-purge-yearend-journals?accountYear=" +
    data.accountYear +
    "&cmpId=" +
    data.cmpId +
    "&tranCode=" +
    data.tranCode +
    "&action=" +
    data.action,
    { headers: authHeader() }
  );
};

const getActivityFeesBySacId = (sacId) => {
  return axios.get(API_URLU + "activity-class-fees-class?sacId=" + sacId, {
    headers: authHeader(),
  });
};

const postActivityFees = (data) => {
  return axios.post(API_URLU + "activity-class-fees", data, {
    headers: authHeader(),
  });
};

const putActivityFees = (data) => {
  return axios.put(API_URLU + "activity-class-fees/" + data.safId, data, {
    headers: authHeader(),
  });
};

const getSchoolSubjectsByCmpid = (cmpId) => {
  return axios.get(API_URLU + "scl-subjects-cmpid?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const postSchoolSubjects = (data) => {
  return axios.post(API_URLU + "scl-subjects", data, {
    headers: authHeader(),
  });
};

const putSchoolSubjects = (data) => {
  return axios.put(API_URLU + "scl-subjects/" + data.sbjId, data, {
    headers: authHeader(),
  });
};

const getGradeSubjectsByGrade = (data) => {
  return axios.get(API_URLU + "scl-grade-subjects-grade-code?cmpId=" + data.cmpId + '&gradeCode=' + data.gradeCode, {
    headers: authHeader(),
  });
};

const postGradeSubjects = (data) => {
  return axios.post(API_URLU + "scl-grade-subjects", data, {
    headers: authHeader(),
  });
};

const putGradeSubjects = (data) => {
  return axios.put(API_URLU + "scl-grade-subjects/" + data.grsId, data, {
    headers: authHeader(),
  });
};

const generateFeesForAllClassStudents = (data) => {
  return axios.get(API_URLU + "generate-class-students-fees?sacId=" + data.sacId + '&cmpId=' + data.cmpId + '&userName=' + data.userName, {
    headers: authHeader(),
  });
};

const calculateTotalExpectedStudentFees = (data) => {
  return axios.get(API_URLU + "scl-calculate-student-expected-fees?sacId=" + data.sacId + '&cmpId=' + data.cmpId + '&studentCode=' + data.studentCode, {
    headers: authHeader(),
  });
};

const getStudentFeesByClassId = (data) => {
  return axios.get(API_URLU + "scl-activity-students-fees-student-class?cmpId=" + data.cmpId + '&studentCode=' + data.studentCode
    + '&sacId=' + data.sacId, {
    headers: authHeader(),
  });
};

const postActivityStudentFees = (data) => {
  return axios.post(API_URLU + "scl-activity-students-fees", data, {
    headers: authHeader(),
  });
};

const putActivityStudentFees = (data) => {
  return axios.put(API_URLU + "scl-activity-students-fees/" + data.csfId, data, {
    headers: authHeader(),
  });
};

const getStudentsByTermCodeAndCalendarYear = (data) => {
  return axios.get(API_URLU + "get-students-year-term?calendarYear=" + data.calendarYear + '&termCode=' + data.termCode
    + '&cmpId=' + data.cmpId, {
    headers: authHeader(),
  });
};

const getGeneralParamsCmpid = (cmpId) => {
  return axios.get(API_URLU + "general-params-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const postGeneralParams = (data) => {
  return axios.post(API_URLU + "general-params", data, {
    headers: authHeader(),
  });
};

const updateGeneralParams = (data) => {
  return axios.put(API_URLU + "general-params?gprId=" + data.gprId, data, {
    headers: authHeader(),
  });
};

const getGeneralParamsById = (gprId) => {
  return axios.get(API_URLU + "general-params-id/" + gprId, {
    headers: authHeader(),
  });
};

const getAccountRepheadersCmpid = (cmpId) => {
  return axios.get(API_URLU + "account-repheaders-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const getAccountRepheadersParamcode = (paramCode, cmpId) => {
  return axios.get(API_URLU + "account-repheaders-paramcode/" + paramCode + "/" + cmpId, {
    headers: authHeader(),
  });
};

const postAccountRepHeaders = (data) => {
  return axios.post(API_URLU + "account-repheaders", data, {
    headers: authHeader(),
  });
};

const updateAccountRepHeaders = (data) => {
  return axios.put(API_URLU + "account-repheaders?marhId=" + data.marhId, data, {
    headers: authHeader(),
  });
};

const getAccountRepHeadersById = (marhId) => {
  return axios.get(API_URLU + "account-repheaders-id/" + marhId, {
    headers: authHeader(),
  });
};

const getAccountRepDetailsHeaderId = (repHeadersMarhId) => {
  return axios.get(API_URLU + "account-repdetails-headerid/" + repHeadersMarhId, {
    headers: authHeader(),
  });
};

const postAccountRepDetails = (data) => {
  return axios.post(API_URLU + "account-repdetails", data, {
    headers: authHeader(),
  });
};

const updateAccountRepDetails = (data) => {
  return axios.put(API_URLU + "account-repdetails?mardId=" + data.mardId, data, {
    headers: authHeader(),
  });
};

const getAccountRepDetailsById = (mardId) => {
  return axios.get(API_URLU + "account-repdetails-id/" + mardId, {
    headers: authHeader(),
  });
};

const getAccountRepAggregatesHeaderId = (repHeadersMarhId) => {
  return axios.get(API_URLU + "account-repaggregates-headerid/" + repHeadersMarhId, {
    headers: authHeader(),
  });
};

const postAccountRepAggregates = (data) => {
  return axios.post(API_URLU + "account-repaggregates", data, {
    headers: authHeader(),
  });
};

const updateAccountRepAggreagates = (data) => {
  return axios.put(API_URLU + "account-repaggregates?maraId=" + data.maraId, data, {
    headers: authHeader(),
  });
};

const getAccountRepAggregatesById = (maraId) => {
  return axios.get(API_URLU + "account-repaggregates-id/" + maraId, {
    headers: authHeader(),
  });
};

const getAccountReportsCmpid = (cmpId) => {
  return axios.get(API_URLU + "account-reports-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const postControlAccounts = (data) => {
  return axios.post(API_URLU + "account-control", data, {
    headers: authHeader(),
  });
};

const putControlAccounts = (actId, data) => {
  return axios.put(API_URLU + "account-control/" + actId, data, {
    headers: authHeader(),
  });
};

const getAccountRepAggreagatesByHeaderDetails = (data) => {
  return axios.get(API_URLU + "account-repaggregates-header-dets?reportFormatId=" + data.reportFormatId + "&sectionNo="
    + data.sectionNo + "&itemNo=" + data.itemNo + "&cmpId=" + data.cmpId, {
    headers: authHeader(),
  });
};

const getAccountRepDetailsByHeaderDetails = (data) => {
  return axios.get(API_URLU + "account-repdetails-header-dets?reportFormatId=" + data.reportFormatId + "&sectionNo="
    + data.sectionNo + "&itemNo=" + data.itemNo + "&cmpId=" + data.cmpId, {
    headers: authHeader(),
  });
};

const postAccountGroups = (data) => {
  return axios.post(API_URLU + "account-groups", data, {
    headers: authHeader(),
  });
};

const updateAccountGroups = (data) => {
  return axios.put(API_URLU + "account-groups/" + data.grpId, data, {
    headers: authHeader(),
  });
};

const getAccountGroupsById = (grpId) => {
  return axios.get(API_URLU + "account-groups-id/" + grpId, {
    headers: authHeader(),
  });
};

const deleteMainAccountGroup = (grpId) => {
  return axios.delete(API_URLU + "account-groups/" + grpId, {
    headers: authHeader(),
  });
};

const getCustomRptFormat = (data) => {
  return axios.get(
    API_URLU +
    "custom-format_report?mngRptFormatId=" +
    data.mngRptFormatId +
    "&firstDate=" + data.firstDate +
    "&lastDate=" +
    data.lastDate +
    "&accYear=" +
    data.accYear,
    { headers: authHeader() }
  );


}

const getMainSubAccountsBySubAccountCode = (subaccountCode, cmpId) => {
  return axios.get(
    API_URLU + "mainsub-subacc/" + subaccountCode + "/" + cmpId,
    {
      headers: authHeader(),
    }
  );
};

const findSalesTransactionCodes = (cmpid) => {
  return axios.get(API_URLU + "cfssale-codes/" + cmpid, {
    headers: authHeader(),
  });
};

const getFeeFinTransByStudentTermCodeAndYear = (data) => {
  return axios.get(API_URLU + "get-fintrans-student-year-term?cmpId=" + data.cmpId + "&termCode="
    + data.termCode + "&studentCode=" + data.studentCode + "&calendarYear=" + data.calendarYear, {
    headers: authHeader(),
  });
};

const getSchoolExamsByCmpid = (cmpId) => {
  return axios.get(API_URLU + "scl-exam-types-cmpid?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const postSchoolExams = (data) => {
  return axios.post(API_URLU + "scl-exam-types", data, {
    headers: authHeader(),
  });
};

const putSchoolExams = (data) => {
  return axios.put(API_URLU + "scl-exam-types/" + data.xmtId, data, {
    headers: authHeader(),
  });
};

const getExamHeadersByExamTypes = (cmpId, examCode) => {
  return axios.get(API_URLU + "scl-exam-headers-exam-type?cmpId=" + cmpId + '&examCode=' + examCode, {
    headers: authHeader(),
  });
};

const postExamHeaders = (data) => {
  return axios.post(API_URLU + "scl-exam-headers", data, {
    headers: authHeader(),
  });
};

const putExamHeaders = (data) => {
  return axios.put(API_URLU + "scl-exam-headers/" + data.xmhId, data, {
    headers: authHeader(),
  });
};

const postExamSubjects = (data) => {
  return axios.post(API_URLU + "scl-exam-subjects", data, {
    headers: authHeader(),
  });
};

const putExamSubjects = (data) => {
  return axios.put(API_URLU + "scl-exam-subjects/" + data.xsjId, data, {
    headers: authHeader(),
  });
};

const getExamSubjectsByHeaderId = (cmpId, xmhId) => {
  return axios.get(API_URLU + "scl-exam-subjects-header-id?cmpId=" + cmpId + '&xmhId=' + xmhId, {
    headers: authHeader(),
  });
};

const getExamClassesByHeaderId = (cmpId, xmhId) => {
  return axios.get(API_URLU + "scl-exam-activity-classes-header?cmpId=" + cmpId + '&xmhId=' + xmhId, {
    headers: authHeader(),
  });
};

const getActivityClassesByTerm = (cmpId, termCode) => {
  return axios.get(API_URLU + "activity-classes-term?cmpId=" + cmpId + '&termCode=' + termCode, {
    headers: authHeader(),
  });
};

const postExamClasses = (data) => {
  return axios.post(API_URLU + "scl-exam-activity-classes", data, {
    headers: authHeader(),
  });
};

const putExamClasses = (data) => {
  return axios.put(API_URLU + "scl-exam-activity-classes/" + data.xclId, data, {
    headers: authHeader(),
  });
};

const getExamEntriesByHeaderIdAndStudentCode = (data) => {
  return axios.get(API_URLU + "scl-exam-entries-student-header?cmpId=" + data.cmpId + '&xmhId=' + data.xmhId + '&studentCode=' + data.studentCode, {
    headers: authHeader(),
  });
};

const postExamEntries = (data) => {
  return axios.post(API_URLU + "scl-exam-entries", data, {
    headers: authHeader(),
  });
};

const putExamEntries = (data) => {
  return axios.put(API_URLU + "scl-exam-entries/" + data.xtrId, data, {
    headers: authHeader(),
  });
};

const getExamAndGrading = (data) => {
  return axios.get(API_URLU + "exam-and-grading?cmpId=" + data.cmpId + "&studentCode=" + data.studentCode, {
    headers: authHeader(),
  });
}

const generateStudentFinancials = (data) => {
  return axios.get(API_URLU + "generate-term-student-financials?termCode=" + data.termCode + '&cmpId=' + data.cmpId + '&year=' + data.year
    + '&studentCode=' + data.studentCode + '&action=' + data.action + '&userName=' + data.userName, {
    headers: authHeader(),
  });
};

const getGradeFeesByYearAndTermCode = (data) => {
  return axios.get(API_URLU + "scl-grade-fees-year-termcode?calendarYear=" + data.calendarYear + '&termCode=' + data.termCode
    + '&gradeCode=' + data.gradeCode + '&cmpId=' + data.cmpId, {
    headers: authHeader(),
  });
};


const getFeeStudents = (data) => {
  return axios.get(API_URLU + "student-fee-breakdown?cmpId=" + data.cmpId + '&studentCode=' + data.studentCode, {
    headers: authHeader(),
  });
}

const postGradeFees = (data) => {
  return axios.post(API_URLU + "scl-grade-fees", data, {
    headers: authHeader(),
  });
};

const getStudentFeePayments = (data) => {
  return axios.get(API_URLU + "student-fee-payment-history?cmpId=" + data.cmpId + '&studentCode=' + data.studentCode, {
    headers: authHeader(),
  });
};

const putGradeFees = (data) => {
  return axios.put(API_URLU + "scl-grade-fees/" + data.grfId, data, {
    headers: authHeader(),
  });
};

const getParentStudentsInfo = (data) => {
  return axios.get(API_URLU + "parent-students-info?cmpId=" + data.cmpId + '&userId=' + data.userId, {
  });
};
const generateClassSetupFees = (data) => {
  return axios.get(API_URLU + "generate-class-setup-fees?sacId=" + data.sacId + '&cmpId=' + data.cmpId + '&userName=' + data.userName, {
    headers: authHeader(),
  });
};

const deleteActivityClassFees = (safId) => {
  return axios.delete(API_URLU + 'activity-class-fees/' + safId, { headers: authHeader() });
};

const getExamActivityClassesByExamHeader = (cmpId, xmhId) => {
  return axios.get(API_URLU + "exam-header-activity-classes?cmpId=" + cmpId + '&xmhId=' + xmhId, {
    headers: authHeader(),
  });
};

const generateSchoolDefaults = (data) => {
  return axios.get(
    API_URLU + 'generate-school-default-data?cmpId=' + data.cmpId + '&sstId=' + data.sstId, { headers: authHeader() });
};

const getExaminationSubjectsByYear = (data) => {
  return axios.get(
    API_URLU + 'scl-examination-class-subjects?cmpId=' + data.cmpId + '&calendarYear=' + data.calendarYear + '&gradeCode=' + data.gradeCode
    , { headers: authHeader() });
};

const createStudentExamMarkEntries = (data) => {
  return axios.get(
    API_URLU + 'scl-create-exam-mark-entries?cmpId=' + data.cmpId + '&xmhId=' + data.xmhId
    + '&user=' + data.user, { headers: authHeader() });
};

const findNumberOfStudentsWithoutMarks = (data) => {
  return axios.get(
    API_URLU + 'scl-find-students-without-marks?cmpId=' + data.cmpId + '&xmhId=' + data.xmhId + '&sacId=' + data.sacId
    + '&examCode=' + data.examCode + '&subjectCode=' + data.subjectCode, { headers: authHeader() });
};

const getExamEntriesByExamSubjects = (data) => {
  return axios.get(
    API_URLU + 'scl-examination-entries-subjects?cmpId=' + data.cmpId + '&xmhId=' + data.xmhId + '&sacId=' + data.sacId
    + '&examCode=' + data.examCode + '&subjectCode=' + data.subjectCode, { headers: authHeader() });
};

const postReceiptsUpload = (formData, cmpId, uploadRefNo) => {
  return axios.post(API_URLU + 'upload-receipts-csv?cmpId=' + cmpId + '&uploadRefNo=' + uploadRefNo, formData,
    {
      headers: authHeader(),
      "Content-Type": "multipart/form-data",
    });
};

const reuploadReceiptsUpload = (formData, cmpId, uploadRefNo) => {
  return axios.post(API_URLU + 'reupload-receipt-csv?cmpId=' + cmpId + '&uploadRefNo=' + uploadRefNo, formData,
    {
      headers: authHeader(),
      "Content-Type": "multipart/form-data",
    });
};

const genReceiptUploadReferenceNo = () => {
  return axios.get(API_URLU + 'get-receipt-upload-ref-no', {
    headers: authHeader()
  });
};

const getAcceptedReceiptUploads = (cmpId, uploadRefNo) => {
  return axios.get(API_URLU + 'accepted-receipt-uploads/' + cmpId + '/' + uploadRefNo, {
    headers: authHeader()
  });
};

const getRejectedReceiptUploads = (cmpId, uploadRefNo) => {
  return axios.get(API_URLU + 'rejected-receipt-uploads/' + cmpId + '/' + uploadRefNo, {
    headers: authHeader()
  });
};

const validateReceiptUploads = (uploadRefNo, cmpId) => {
  return axios.get(API_URLU + 'validate-receipt-upload/' + uploadRefNo + '/' + cmpId, {
    headers: authHeader()
  });
};

const saveValidatedReceiptUploads = (data) => {
  return axios.get(API_URLU + 'save-validated-receipt-upload?cmpId=' + data.cmpId + '&uploadRefNo=' + data.uploadRefNo, {
    headers: authHeader()
  });
};

const getActivityClassSchedulesByClassId = (data) => {
  return axios.get(API_URLU + "scl-activity-class-schedule-class?cmpId=" + data.cmpId + '&sacId=' + data.sacId, {
    headers: authHeader(),
  });
};

const getActivityClassSchedulesByClassIdAndDate = (data) => {
  return axios.get(API_URLU + "scl-activity-class-schedule-class-date?cmpId=" + data.cmpId + '&sacId=' + data.sacId
    + '&date=' + data.date, {
    headers: authHeader(),
  });
};

const postActivityClassSchedules = (data) => {
  return axios.post(API_URLU + "scl-activity-class-schedule", data, {
    headers: authHeader(),
  });
};

const putActivityClassSchedules = (data) => {
  return axios.put(API_URLU + "scl-activity-class-schedule/" + data.scsId, data, {
    headers: authHeader(),
  });
};

const getClassActivityTypesByCmpId = (data) => {
  return axios.get(API_URLU + "scl-class-activity-types-cmpid?cmpId=" + data.cmpId, {
    headers: authHeader(),
  });
};

const postClassActivityTypes = (data) => {
  return axios.post(API_URLU + "scl-class-activity-types", data, {
    headers: authHeader(),
  });
};

const putClassActivityTypes = (data) => {
  return axios.put(API_URLU + "scl-class-activity-types/" + data.satId, data, {
    headers: authHeader(),
  });
};

const getActivityClassesByCalendarYear = (data) => {
  return axios.get(API_URLU + "activity-classes-year?cmpId=" + data.cmpId + '&calendarYear=' + data.calendarYear, {
    headers: authHeader(),
  });
};

const postGradingSystems = (data) => {
  return axios.post(API_URLU + "scl-grading-system", data, {
    headers: authHeader(),
  });
};

const putGradingSystems = (data) => {
  return axios.put(API_URLU + "scl-grading-system/" + data.sgsId, data, {
    headers: authHeader(),
  });
};

const getGradingSystemsByCmpId = (data) => {
  return axios.get(API_URLU + "scl-grading-system-cmpid?cmpId=" + data.cmpId, {
    headers: authHeader(),
  });
};

const postGradingSystemDetails = (data) => {
  return axios.post(API_URLU + "scl-grading-details", data, {
    headers: authHeader(),
  });
};

const putGradingSystemDetails = (data) => {
  return axios.put(API_URLU + "scl-grading-details/" + data.sgdId, data, {
    headers: authHeader(),
  });
};

const getGradingSystemDetailsBySystem = (data) => {
  return axios.get(API_URLU + "scl-grading-details-header?cmpId=" + data.cmpId + '&sgsId=' + data.sgsId, {
    headers: authHeader(),
  });
};

const getAllClassFeeTotalsByYear = (data) => {
  return axios.get(API_URLU + "class-fee-totals-year?calendarYear=" + data.calendarYear + '&cmpId=' + data.cmpId, {
    headers: authHeader(),
  });
};

const getClassFeeDetailsByClassId = (data) => {
  return axios.get(API_URLU + "class-fee-details-class?sacId=" + data.sacId + '&cmpId=' + data.cmpId, {
    headers: authHeader(),
  });
};

const getStudentFeeTotalsByClassId = (data) => {
  return axios.get(API_URLU + "student-fee-totals-class?sacId=" + data.sacId + '&cmpId=' + data.cmpId, {
    headers: authHeader(),
  });
};

const getStudentFeeDetailsByClassIdAndStudentCode = (data) => {
  return axios.get(API_URLU + "student-fee-details-class-student?sacId=" + data.sacId + '&cmpId=' + data.cmpId
    + '&studentCode=' + data.studentCode, {
    headers: authHeader(),
  });
};

const getStudentsstm = (data) => {
  return axios.get(API_URLU + "student-statement?cmpId=" + data.cmpId + '&subaccountCode=' + data.subaccountCode, {
    headers: authHeader(),
  });
};

const getStudentBal = (data) => {
  return axios.get(API_URLU + "student-balance?cmpId=" + data.cmpId + '&subaccountCode=' + data.subaccountCode, {
    headers: authHeader(),
  });
};

const getStudentStatementReport = (data) => {
  return axios.post(
    API_URLU + "student-statement-report?cmpId=" + data.cmpId + '&sshId=' + data.sshId + '&repName=' + data.repname + 
    '&reportFormat=' + data.format + '&balance=' + data.balance, data, {
    headers: authHeader(),
  });
};

const getStudentFeeBalancesByCmpId = (cmpId) => {
  return axios.get(API_URLU + "student-fee-balances-cmpid?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getActivityClassTeachersBySacId = (data) => {
  return axios.get(API_URLU + "scl-activity-class-teachers-class?sacId=" + data.sacId + '&cmpId=' + data.cmpId, {
    headers: authHeader(),
  });
};

const postActivityClassTeachers = (data) => {
  return axios.post(API_URLU + "scl-activity-class-teachers", data, {
    headers: authHeader(),
  });
};

const putActivityClassTeachers = (data) => {
  return axios.put(API_URLU + "scl-activity-class-teachers/" + data.satId, data, {
    headers: authHeader(),
  });
};

const getExamGradingStudents = (cmpId) => {
  return axios.get(API_URLU + "scl-exam-grading-students?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getSchoolParents = (cmpId) => {
  return axios.get(API_URLU + "scl-school-parents?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getEmployeeDetailsByUsernameAndCmpId = (data) => {
  return axios.get(API_URLU + "scl-teachers-sspusername?sspUsername=" + data.sspUsername + '&cmpId=' + data.cmpId, {
    headers: authHeader(),
  });
};

const getClassTeacherActivityClassesByCalendarYear = (data) => {
  return axios.get(API_URLU + "activity-class-teacher-classes-year?cmpId=" + data.cmpId + '&calendarYear=' + data.calendarYear
    + '&teacherCode=' + data.teacherCode, {
    headers: authHeader(),
  });
};

const getSubjectTeacherActivityClassesByCalendarYear = (data) => {
  return axios.get(API_URLU + "activity-subject-teacher-classes-year?cmpId=" + data.cmpId + '&calendarYear=' + data.calendarYear
    + '&teacherCode=' + data.teacherCode, {
    headers: authHeader(),
  });
};

const getTeacherSubjectsByClassId = (data) => {
  return axios.get(API_URLU + "teacher-subjects-class-id?cmpId=" + data.cmpId + '&sacId=' + data.sacId
    + '&teacherCode=' + data.teacherCode, {
    headers: authHeader(),
  });
};

const getTeacherExaminationSubjectsByYear = (data) => {
  return axios.get(
    API_URLU + 'teacher-examination-class-subjects?cmpId=' + data.cmpId + '&calendarYear=' + data.calendarYear + '&gradeCode=' + data.gradeCode
    + '&teacherCode=' + data.teacherCode, { headers: authHeader() });
};

const deleteActivityStudent = (sasId) => {
  return axios.delete(API_URLU + "activity-class-students/" + sasId, {
    headers: authHeader(),
  });
};

export default {
  getUserById,
  getPendingSales,
  postSale,
  delSale,
  putSale,
  getSalesByDate,
  getSalesByShop,
  getUserShops,
  getDaySales,
  getUserSales,
  getAllSales,
  getUsers,
  postUser,
  getCompById,
  getCompanies,
  postComp,
  getSystemById,
  getSystems,
  postSystem,
  postUserComp,
  postUserSystems,
  getUserComp,
  getCompSystems,
  getUserCompSystems,
  getUserCompUSystems,
  getCustomerById,
  getCustomers,
  postCustomer,
  putCustomer,
  getEmployeeById,
  getEmployeeByUsername,
  getEmployees,
  getPagedEmployees,
  postEmployee,
  putEmployee,
  getClassification,
  getGeneral,
  getFiles,
  saveInvoice,
  getInvoiceInfo,
  getScheduledLeaves,
  postLeaveSchedule,
  getLeaveAccruals,
  getLeaveApplications,
  postLeaveApplication,
  getLeaveTransactions,
  getLeaveRejections,
  getLeaveTypes,
  getReturnDate,
  uploadFile,
  uploadExcel,
  postTempBranch,
  getTempBranch,
  getPastDays,
  postDay,
  getDaysStatus,
  putDay,
  getMaxDate,
  getSaleStatus,
  updatePass,
  updateUser,
  updateUserImg,
  getApprovedSales,
  getAdminSalesByDate,
  getAllShops,
  getAdminSalesByShop,
  getStockCodes,
  getQuoteId,
  getQuoteInfo,
  delQuote,
  getQuoteReport,
  postQuoteHeader,
  postQuoteDetails,
  genCombinedQuote,
  getCombinedQuotes,
  archCombQuote,
  listSingleQuoutes,
  listCombinedQuoutes,
  companyVatRates,
  checkVatDates,
  postVatRates,
  delVatRate,
  putVatRate,
  companyStdRates,
  postStandardRates,
  delStdRate,
  putStdRate,
  companyGenRates,
  postGeneralRates,
  delGenRate,
  putGenRate,
  currentPeriods,
  pastPeriods,
  closePeriod,
  postNewPeriod,
  putIstPeriod,
  getCompanyProducts,
  getProductDetails,
  postIstProducts,
  putIstProducts,
  delIstProduct,
  getCompanySuppliers,
  getSupplierDetails,
  postIstSuppliers,
  putIstSuppliers,
  getSupplierStocks,
  getSupplerProductDetails,
  putIstSupplierProducts,
  getCombinedSingle,
  updateStockQuote,
  postIstSupplierProducts,
  getCompanyTariffPeriods,
  getTariffCashRates,
  getRateDetails,
  putCashRateDetails,
  getCheckOffMarkupPercs,
  getMarkupPercDetails,
  putMarkupDetails,
  closeTariffPeriod,
  getTrpHpDeposit,
  getHPDepositDetails,
  putHpDepositDetails,
  getTrpDiscounts,
  getDiscountDetails,
  putDiscountDetails,
  getTrpInstalMonths,
  getInstalMonthsDetails,
  putInstalMonths,
  getHpMarkupRates,
  getMarkupDetails,
  putMarkupRates,
  getHpMarkupPercs,
  getMarkupPerc,
  putMarkupPercs,
  copyPeriods,
  getProductHist,
  getCompanyStocks,
  postCashRateDetails,
  delCashRate,
  postMarkupDetails,
  delMarkup,
  postHpDepositDetails,
  delHpDepositDetails,
  postDiscountDetails,
  delDiscountDetails,
  postInstalMonths,
  delInstalMonths,
  postMarkupRates,
  delMarkupRate,
  getPriceCataloq,
  getJointYn,
  getJointStockCodes,
  getStockCatalogue,
  getActiveStocks,
  getMinDate,
  getStockCheckOff,
  getSupplierPriceList,
  getSupplierPastPriceList,
  updatePriceCatalogue,
  addNewPriceListItem,
  updatePriceList,
  UpdateAllPrices,
  getJointStocks,
  addJointStocks,
  getUserRights,
  approveVATRates,
  approveSTDRates,
  approveGENRates,
  approvePeriod,
  allPeriods,
  clearStockPrices,
  updateStockPrices,
  updateTariffPeriod,
  approvetariffPeriod,
  getCataloguePeriods,
  inteGrateWithKct,
  getCompanyStockCodes,
  genNoneStockQuote,
  listNonStockQuotes,
  approveCashRate,
  approveCheckOff,
  getActiveEndDate,
  approveStock,
  getMenuLevels,
  getAddTempItem,
  getPoH,
  getPoHVW,
  getReqH,
  getPoD,
  getReqD,
  getPolNo,
  postPoH,
  postPoD,
  getReqSummary,
  getPoSummary,
  getPohApproval,
  getPurchaseReport,
  getCustomerByCmpId,
  genCombQuoteHeader,
  genCombNoneStockQuote,
  listCombNonStockQuotes,
  getCombQuoteReport,
  postGaaH,
  postGaaD,
  getUpdatePoDetails,
  getPoNotInGaa,
  getGaaHVW,
  getGaaHVWItems,
  getUserBranches,
  generateCombinedNonStockQuote,
  genCombQuoteNoneStockDetails,
  postGap,
  postStkTransH,
  postStkTransD,
  getShopTransfers,
  getShopTransferDetails,
  getTransferInvoiceReport,
  getSupplierEmail,
  sendLpoMail,
  getReceiptTranCodes,
  getPaymentModes,
  getCustomerCodes,
  getPolicyInformation,
  getAddress,
  getAllBankAccounts,
  getDocDetails,
  docAvailable,
  postReceiptHeader,
  putReceiptHeader,
  postReceiptDetails,
  putReceiptDetails,
  getReceiptDetails,
  getCompanyBanks,
  getReceiptHeaderApprovalStatus,
  approveReceiptHeader,
  saleItems,
  postSalesHeader,
  postSalesDetails,
  postSalesParticular,
  getSalesHeader,
  getCustomerByCmpIdAndId,
  getGapItemsByGaaNo,
  poReports,
  getPoReportDetails,
  getPurchaseReport2,
  updateMialSent,
  cancelPO,
  getSaleTypes,
  companyReceipts,
  getSelectedReceiptDetails,
  getAllCreditAccounts,
  getPaymentHeaders,
  getPaymentDetailsByHeaderId,
  getInvoiceTransactionCodes,
  getPaymentTransactionCodes,
  getInvoiceHeaders,
  getOurRef,
  getMainAccounts,
  getSubAccountsByMain,
  getCustBank,
  getBranches,
  getDepartments,
  postPaymentDetails,
  postPaymentHeaders,
  putPaymentHeaders,
  getPaymentHeaderByHeaderId,
  postGltranHeaders,
  postGltranDetails,
  getPaymentReport,
  getPaymentDetails,
  getAllPaymentHeaders,
  approvePaymentHeader,
  getPaymentDocNumber,
  getInvoiceBalance,
  findPaymentModes,
  getTranTypes,
  linkCustomerAccount,
  getLinkedCustomerAccounts,
  getUnbankedReceipts,
  getCustomerSubaccounts,
  generateCustomerSubaccount,
  getBankingTranCode,
  getBankingDocNumber,
  postReceiptBankHeader,
  postReceiptBankDetails,
  getGaaDByGaaNo,
  getSaleFinTrans,
  genSaleFinTrans,
  getSalesDetailsBySshId,
  getSalesParticularBySshId,
  getUpdate,
  updateCompSystems,
  getUserAllSubSystems,
  getUserUnsubscribedSystems,
  getCompUSystems,
  deleteUserComp,
  updateUserComp,
  getUserBycmp,
  getMasterUserComp,
  getUserByName,
  getSacMembers,
  postSacMembers,
  getMemberCode,
  usersPreSelfService,
  getGeneralSettingsByCmpId,
  putGeneralSettings,
  getSacMembersById,
  putSacMembers,
  getLoanTypes,
  getChargeTypes,
  getContributionTypes,
  postLoanTypes,
  postShareTypes,
  postChargeTypes,
  getLoanTypesById,
  getShareTypesById,
  getChargeTypesById,
  putLoanTypes,
  putShareTypes,
  putChargeTypes,
  delLoanType,
  delShareTypes,
  delChargeTypes,
  getSaccoControlsByCmpId,
  putSaccoControls,
  getPendingMemApplications,
  getApprovedMemApplications,
  getRejectedMemApplications,
  getCompletedMemApplications,
  getPendingSaccoApplications,
  getApprovedSaccoApplications,
  getRejectedSaccoApplications,
  getCompletedSaccoApplications,
  postProvLoans,
  getProvLoansById,
  getApprLoansById,
  putProvLoans,
  putApprLoans,
  getSacMembersByEmailandCmpId,
  getSacMembersByEmail,
  getTotalMemberLoanNumber,
  getPaymentsWithBalance,
  approveMemberLoans,
  getBankBranchesBySacco,
  getBankHeadersBySacco,
  postBankHeaders,
  putBankHeaders,
  getBankHeadersById,
  putBankBranches,
  postBankBranches,
  getBankBranchesByHeader,
  getBankBranchesById,
  getBankBranchesByCmpId,
  delBankBranches,
  delBankHeaders,
  getSacLoanGuarantors,
  getSacCurrencies,
  getCurrencyCodesById,
  postCurrencyCodes,
  putCurrencyCodes,
  delCurrencyCodes,
  getTotalMemberLoanBalance,
  getTotalMemberLoanAmount,
  getTotalActiveLoans,
  postLoanGuarantors,
  getLoanGuarantorsbyLoan,
  delLoanGuarantors,
  genSacSerials,
  companySystemLink,
  adminSystemLink,
  getPendingSaccoSavingsHeaders,
  getApprovedSaccoSavingsHeaders,
  getSaccoSavingsDetailsByHeaders,
  getBatchNumber,
  postSacSavings,
  postSacSavingsDetails,
  getSavingsDetailsById,
  putSavingsDetails,
  delMemberSavings,
  putSavingsHeaders,
  getSavingsHeadersById,
  getPendGuaranteeRequests,
  getAppRejGuaranteeRequests,
  getMemPendGuaranteeRequests,
  getMemAppRejGuaranteeRequests,
  updateHeaderTotals,
  getGuaranteeRequestsById,
  putLoanGuarantors,
  postSacMembersUpload,
  postSacMemberSavingsUpload,
  getActiveBankHeadersBySacco,
  getActBankBranchesByHeader,
  updatebankBranchCode,
  getActiveContributionTypes,
  getActiveLoanTypes,
  getActiveChargeTypes,
  getMemberSaccoSavings,
  getAcceptedLoanGuarantorsbyLoan,
  getSavingsUserComp,
  acceptLoanGuarantee,
  postLoanGuarantorsSendEmail,
  declineLoanGuarantee,
  getActiveSacCurrencies,
  getMemberSaccoLimits,
  getSchoolUserCompanies,
  companyMenuLink,
  getSchoolStudents,
  getStudentCode,
  postSchoolStudents,
  putSchoolStudents,
  getSchoolStudentsById,
  linkSchoolUser,
  postSchoolStudentsUpload,
  validateStudentUploads,
  getRejectedStudentUploads,
  getAcceptedStudentUploads,
  genStudentUploadReferenceNo,
  reuploadSchoolStudentsUpload,
  postAcceptedSchoolStudentUploads,
  emailStudentsWithoutAccounts,
  linkUnlinkedStudents,
  getAllPermittedEmployees,
  getContractTypesByCmp,
  getChrCompanyBranches,
  getEmployeeByCategoryCode,
  getUserPermittedChrEmpCategories,
  getChrFundingSourceGeneralCodesByCmpId,
  getChrCompany,
  getChrRelationTypesByCmpId,
  getChrJobTitlesByCmp,
  getActiveChrEmployeesByCmp,
  getChrCompanyDepartments,
  getChrJobGroupsByCmp,
  getChrLeaveTypesByCmp,
  getChrAnnualLeaveTypesByCmp,
  getChrCoursesByCmp,
  getFixedAssetCategoriesByCmp,
  getItemsByCategory,
  postEmployeePeriods,
  postEmployeeRelation,
  putEmployeeRelation,
  postEmployeeLeave,
  putEmployeeLeave,
  postEmployeeQualification,
  putEmployeeQualification,
  postEmployeeReferee,
  putEmployeeReferee,
  postEmployeeItem,
  putEmployeeItem,
  getEmployeeRelationsByEmployeeCode,
  getEmployeeItemsByEmployeeCode,
  getEmployeeLeavesByEmployeeCode,
  getEmployeeRefereesByEmployeeCode,
  getEmployeePeriodsByEmployeeCode,
  generateEmployeeCode,
  getCustTypeByCmpId,
  getClientTypeByCmpId,
  getIdentificationTypeByCmpId,
  getOccupationCodesByCmpId,
  getOnluserInsurerCustomersByCmpId,
  getCustClassificationByCmpId,
  getDiscountCategoryByCmpId,
  getUsersPermittedForCustomers,
  getCompanyClassifiedCustomerCode,
  postOnlineCredential,
  getPermittedCustomerById,
  putOnlineCredential,
  getAllCfsMainAccounts,
  getMainAccountWithGroupsByCmpId,
  getFrozenMainAccountWithGroupsByCmpId,
  getCfsAccountYearsByCmpid,
  getAccountGroupsByCmpId,
  getCfsMainSubAccountsbyAccountCode,
  getSubAccountsToLinkByAccountCode,
  getAccBudgetsByCmpIdandYearandAccountCode,
  getAccBranchBudgetsByAccountYearandMonth,
  getAccDeptBudgetsByYearAndMonthAccountAndBranch,
  postCfsMainAccounts,
  postCfsMainSubAccounts,
  getCfsMainAccountsById,
  putCfsMainAccounts,
  delinkSubAccount,
  deleteMainAccount,
  getCompanyBranches,
  getBranch,
  getDepartmentsByCmpId,
  postDepartments,
  updateDepartments,
  getDepartmentsById,
  postCostCenters,
  updateCostCenters,
  getCostCentersById,
  getCostCentersByCmpId,
  putCompany,
  putBranch,
  postBranch,
  getCfsCompanyBanks,
  getCfsCompanyBankChqDetails,
  getMainAccountsByCmpId,
  getActiveCurrency,
  postCfsCompanyBanks,
  updateCfsCompanyBanks,
  postCfsCompanyBankCheque,
  updateCfsCompanyBankCheque,
  getSubAccountsByCmpId,
  getCustomersToCreateSubAccount,
  postMainSubAccounts,
  postSubAccounts,
  putSubAccounts,
  getSubAccountsById,
  getAccountsToLinkBySubaccountCode,
  getAllTranCodes,
  postTranCode,
  updateTranCode,
  getAllTranPrivs,
  postTranPrivs,
  updateTranPrivs,
  getCompanySystemUsers,
  getTranSerialsByCmpId,
  getAllTranSerials,
  updateTranSerials,
  postTranSerials,
  getReceiptHeadersByCmpid,
  getReceiptHeader,
  deleteReceiptDetail,
  getReceiptDetailsByHeaderId,
  findPaymentModesByCmpId,
  findReceiptTransactionCodes,
  getCashBankMainAccounts,
  getAssetMainAccountsSubAccounts,
  getAllglTransactions,
  getAllCustomersByCmpId,
  getBranchesByCmpId,
  getCustomerSalesForReceiptsByCmpId,
  getWalkinSalesForReceiptsByCmpId,
  getControlAccountsByCmpId,
  getTransactionPrivsByCmpIdAndTranCodeAndUserName,
  getReceiptGlTransactionDetailsByHeaderId,
  getJournalVoucher,
  getReceipt,
  fetchAllUnbankedReceipts,
  fetchFilteredUnbankedReceipts,
  findOtherTransactionCodes,
  fetchAllReceiptBankingHeaders,
  getBankedReceiptDetailsByHeaderId,
  getReceiptBankingGlTransactionDetailsByHeaderId,
  putReceiptBankHeader,
  approveReceiptBanking,
  getInvoicesWithBalanceForPayment,
  getPoReportDetailsByPhd,
  getPoHBalnce,
  getPaymentParticularByHeaderId,
  postPaymentInvoices,
  getInvoicesPaidByPayment,
  getPaymentGlTransactionDetailsByHeaderId,
  getPaymentsonSelectedInvoice,
  getDefaultAccounts,
  getPaymentVoucher,
  getInvoiceReport,
  getAllCompanySuppliers,
  getJournalsByCmpId,
  getJournalsByCmpIdAndId,
  getJournalDetailsByHeaders,
  getJournalRepDetailsByHeaders,
  postJournalHeaders,
  postJournalDetails,
  putJournalHeaders,
  getJournalHeadersById,
  putJournalDetails,
  getJournalDetailsById,
  deleteJournalDetail,
  approveJournalHeader,
  reverseGlTransaction,
  getJournalReport,
  getJournalGlTransactionDetailsByHeaderId,
  getJournalTransactionCodes,
  getCfsReportcategories,
  runAccountsReport,
  getAccountReports,
  getGlActivityReport,
  getTrialBalanceReport,
  getJournalListingReport,
  getPaymentListingReport,
  getReceiptListingReport,
  getMainAccountsReport,
  getMainSubAccountsReport,
  getStatementOfAccountsReport,
  getDebtorsAgedListingReport,
  getCfsReportsByCatId,
  runSchoolReport,
  getSchoolReportCategories,
  getSchoolReportsByCatCode,
  getStudentsListingReport,
  getSchoolYearsByCmpid,
  postSchoolYears,
  putSchoolYears,
  getSchoolTermsByCmpid,
  postSchoolTerms,
  putSchoolTerms,
  getSchoolStreamsByCmpid,
  postSchoolStreams,
  putSchoolStreams,
  getSchoolGradesByCmpid,
  postSchoolGrades,
  putSchoolGrades,
  getActivityTermsByCalendarYear,
  postActivityTerms,
  putActivityTerms,
  postActivityClasses,
  putActivityClasses,
  getActivityClassesByStreamAndGrade,
  getSchoolEmployees,
  getSchoolJobCategories,
  getEmployeeRelationsByEmployeeCodeCmpId,
  getChrRelationTypesByCompanyId,
  getActiveSchoolTeachersByCmpid,
  getActivityStudentsBySacId,
  postActivityStudents,
  putActivityStudents,
  getSchoolFeesByCmpid,
  postSchoolFees,
  putSchoolFees,
  getEndYearJournalsByCmpId,
  generateEndYearJournalBrief,
  clearOrPurgeEndYearJournalBrief,
  getActivityFeesBySacId,
  postActivityFees,
  putActivityFees,
  getSchoolSubjectsByCmpid,
  postSchoolSubjects,
  putSchoolSubjects,
  getGradeSubjectsByGrade,
  postGradeSubjects,
  putGradeSubjects,
  generateFeesForAllClassStudents,
  getStudentFeesByClassId,
  putActivityStudentFees,
  postActivityStudentFees,
  calculateTotalExpectedStudentFees,
  tenantPost,
  setTenants,
  getTenants,
  getStudentsByTermCodeAndCalendarYear,
  getGeneralParamsCmpid,
  postGeneralParams,
  updateGeneralParams,
  getGeneralParamsById,
  getAccountRepheadersCmpid,
  getAccountRepheadersParamcode,
  postAccountRepHeaders,
  updateAccountRepHeaders,
  getAccountRepDetailsHeaderId,
  getAccountRepHeadersById,
  postAccountRepDetails,
  updateAccountRepDetails,
  getAccountRepDetailsById,
  postAccountRepAggregates,
  getAccountRepAggregatesHeaderId,
  updateAccountRepAggreagates,
  getAccountRepAggregatesById,
  getAccountReportsCmpid,
  postControlAccounts,
  putControlAccounts,
  getAccountRepAggreagatesByHeaderDetails,
  getAccountRepDetailsByHeaderDetails,
  postAccountGroups,
  updateAccountGroups,
  getAccountGroupsById,
  deleteMainAccountGroup,
  getCustomRptFormat,
  getMainSubAccountsBySubAccountCode,
  findSalesTransactionCodes,
  getFeeFinTransByStudentTermCodeAndYear,
  getSchoolExamsByCmpid,
  postSchoolExams,
  putSchoolExams,
  getExamHeadersByExamTypes,
  postExamHeaders,
  putExamHeaders,
  postExamSubjects,
  putExamSubjects,
  getExamSubjectsByHeaderId,
  getExamClassesByHeaderId,
  postExamClasses,
  putExamClasses,
  getActivityClassesByTerm,
  getExamEntriesByHeaderIdAndStudentCode,
  postExamEntries,
  putExamEntries,
  getExamAndGrading,
  getFeeStudents,
  getStudentFeePayments,
  getParentStudentsInfo,
  generateStudentFinancials,
  getGradeFeesByYearAndTermCode,
  postGradeFees,
  putGradeFees,
  generateClassSetupFees,
  deleteActivityClassFees,
  getExamActivityClassesByExamHeader,
  generateSchoolDefaults,
  getExaminationSubjectsByYear,
  createStudentExamMarkEntries,
  findNumberOfStudentsWithoutMarks,
  getExamEntriesByExamSubjects,
  postReceiptsUpload,
  reuploadReceiptsUpload,
  genReceiptUploadReferenceNo,
  getAcceptedReceiptUploads,
  getRejectedReceiptUploads,
  validateReceiptUploads,
  saveValidatedReceiptUploads,
  getActivityClassSchedulesByClassId,
  getActivityClassSchedulesByClassIdAndDate,
  putActivityClassSchedules,
  postActivityClassSchedules,
  getClassActivityTypesByCmpId,
  getActivityClassesByCalendarYear,
  putClassActivityTypes,
  postClassActivityTypes,
  postGradingSystems,
  putGradingSystems,
  getGradingSystemsByCmpId,
  postGradingSystemDetails,
  putGradingSystemDetails,
  getGradingSystemDetailsBySystem,
  getAllClassFeeTotalsByYear,
  getClassFeeDetailsByClassId,
  getStudentFeeTotalsByClassId,
  getStudentFeeDetailsByClassIdAndStudentCode,
  getStudentsstm,
  getStudentBal,
  getStudentStatementReport,
  getStudentFeeBalancesByCmpId,
  getActivityClassTeachersBySacId,
  postActivityClassTeachers,
  putActivityClassTeachers,
  getExamGradingStudents,
  getSchoolParents,
  getEmployeeDetailsByUsernameAndCmpId,
  getClassTeacherActivityClassesByCalendarYear,
  getSubjectTeacherActivityClassesByCalendarYear,
  getTeacherSubjectsByClassId,
  getTeacherExaminationSubjectsByYear,
  deleteActivityStudent,
};
